/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Auth_BannedInputs */
/** @typedef {{}} Auth_Mail_Send_FailedInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Auth_Resend_Too_SoonInputs */
/** @typedef {{}} Cv_As_BroadcastInputs */
/** @typedef {{}} Cv_BroadcastInputs */
/** @typedef {{}} Cv_Broadcast_HintInputs */
/** @typedef {{}} Cv_Broadcast_No_ReplyInputs */
/** @typedef {{}} Cv_CancelInputs */
/** @typedef {{}} Cv_Cannot_PostInputs */
/** @typedef {{}} Cv_Col_Last_MessageInputs */
/** @typedef {{}} Cv_Col_NameInputs */
/** @typedef {{}} Cv_Col_SpaceInputs */
/** @typedef {{}} Cv_Col_UpdatedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Dm_EmptyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Cv_Dm_Empty_GroupInputs */
/** @typedef {{}} Cv_Dm_Empty_SelfInputs */
/** @typedef {{}} Cv_Dm_Empty_UnknownInputs */
/** @typedef {{ when: NonNullable<unknown> }} Cv_Dm_LastInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Dm_MembersInputs */
/** @typedef {{}} Cv_Dm_MenuInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Dm_Self_NameInputs */
/** @typedef {{}} Cv_DmsInputs */
/** @typedef {{}} Cv_Dms_EmptyInputs */
/** @typedef {{}} Cv_Dms_None_MatchInputs */
/** @typedef {{}} Cv_Dms_None_UnreadInputs */
/** @typedef {{}} Cv_Dms_StartInputs */
/** @typedef {{}} Cv_EditInputs */
/** @typedef {{}} Cv_Edit_LabelInputs */
/** @typedef {{}} Cv_Emoji_AddInputs */
/** @typedef {{}} Cv_Emoji_Add_SectionInputs */
/** @typedef {{}} Cv_Emoji_Cannot_AddInputs */
/** @typedef {{}} Cv_Emoji_ChooseInputs */
/** @typedef {{}} Cv_Emoji_Choose_ImageInputs */
/** @typedef {{}} Cv_Emoji_EmptyInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_Emoji_FullInputs */
/** @typedef {{}} Cv_Emoji_ImageInputs */
/** @typedef {{ kb: NonNullable<unknown> }} Cv_Emoji_Image_NoteInputs */
/** @typedef {{}} Cv_Emoji_ListInputs */
/** @typedef {{}} Cv_Emoji_NameInputs */
/** @typedef {{}} Cv_Emoji_Name_NoteInputs */
/** @typedef {{}} Cv_Emoji_Name_RuleInputs */
/** @typedef {{}} Cv_Emoji_No_ImageInputs */
/** @typedef {{}} Cv_Emoji_Pick_ImageInputs */
/** @typedef {{}} Cv_Emoji_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Emoji_Remove_TitleInputs */
/** @typedef {{ kb: NonNullable<unknown> }} Cv_Emoji_Too_LargeInputs */
/** @typedef {{}} Cv_FilterInputs */
/** @typedef {{}} Cv_Filter_AllInputs */
/** @typedef {{}} Cv_Filter_BroadcastsInputs */
/** @typedef {{}} Cv_Filter_SpaceInputs */
/** @typedef {{}} Cv_Filter_Space_AllInputs */
/** @typedef {{}} Cv_Filter_UnreadInputs */
/** @typedef {{}} Cv_InboxInputs */
/** @typedef {{}} Cv_Inbox_Reason_PostedInputs */
/** @typedef {{}} Cv_Load_FailedInputs */
/** @typedef {{}} Cv_Loading_OlderInputs */
/** @typedef {{}} Cv_Mark_ReadInputs */
/** @typedef {{}} Cv_Me_DmsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Members_CountInputs */
/** @typedef {{ count: NonNullable<unknown> }} Cv_Members_MoreInputs */
/** @typedef {{}} Cv_Mention_Cannot_SeeInputs */
/** @typedef {{}} Cv_Message_MenuInputs */
/** @typedef {{}} Cv_MoveInputs */
/** @typedef {{}} Cv_Move_ActionInputs */
/** @typedef {{}} Cv_NarrowInputs */
/** @typedef {{}} Cv_Narrow_NameInputs */
/** @typedef {{}} Cv_Narrow_TitleInputs */
/** @typedef {{}} Cv_New_DmInputs */
/** @typedef {{}} Cv_New_Dm_ChosenInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_New_Dm_LimitInputs */
/** @typedef {{}} Cv_New_Dm_NobodyInputs */
/** @typedef {{}} Cv_New_Dm_PeopleInputs */
/** @typedef {{}} Cv_New_Dm_SearchInputs */
/** @typedef {{}} Cv_New_Dm_StartInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_New_Dm_UnpickInputs */
/** @typedef {{}} Cv_New_TopicInputs */
/** @typedef {{}} Cv_New_Topic_HintInputs */
/** @typedef {{}} Cv_New_Topic_InInputs */
/** @typedef {{}} Cv_No_DescriptionInputs */
/** @typedef {{}} Cv_No_SpaceInputs */
/** @typedef {{}} Cv_Not_FoundInputs */
/** @typedef {{}} Cv_PinInputs */
/** @typedef {{}} Cv_Pin_DownInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Pin_Down_LabelInputs */
/** @typedef {{}} Cv_Pin_GoneInputs */
/** @typedef {{}} Cv_Pin_UpInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Pin_Up_LabelInputs */
/** @typedef {{}} Cv_PinsInputs */
/** @typedef {{}} Cv_Pins_EmptyInputs */
/** @typedef {{}} Cv_Pins_Empty_CanInputs */
/** @typedef {{}} Cv_Post_LabelInputs */
/** @typedef {{}} Cv_Post_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Post_Placeholder_DmInputs */
/** @typedef {{ names: NonNullable<unknown> }} Cv_Post_Placeholder_Dm_GroupInputs */
/** @typedef {{}} Cv_Post_Placeholder_Dm_SelfInputs */
/** @typedef {{}} Cv_ReactInputs */
/** @typedef {{}} Cv_React_NoneInputs */
/** @typedef {{}} Cv_React_SearchInputs */
/** @typedef {{}} Cv_Reaction_CheckInputs */
/** @typedef {{}} Cv_Reaction_EyeInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Cv_Reaction_LabelInputs */
/** @typedef {{}} Cv_ReactionsInputs */
/** @typedef {{}} Cv_Recent_TopicsInputs */
/** @typedef {{}} Cv_RemoveInputs */
/** @typedef {{}} Cv_Remove_BodyInputs */
/** @typedef {{}} Cv_Remove_TitleInputs */
/** @typedef {{}} Cv_RenameInputs */
/** @typedef {{}} Cv_Rename_ActionInputs */
/** @typedef {{}} Cv_SaveInputs */
/** @typedef {{}} Cv_Save_FailedInputs */
/** @typedef {{}} Cv_Send_FailedInputs */
/** @typedef {{}} Cv_Settings_EmojiInputs */
/** @typedef {{}} Cv_Settings_Emoji_DescriptionInputs */
/** @typedef {{}} Cv_Settings_Emoji_ShortInputs */
/** @typedef {{}} Cv_SpaceInputs */
/** @typedef {{}} Cv_Space_MissingInputs */
/** @typedef {{}} Cv_Space_OverviewInputs */
/** @typedef {{}} Cv_Start_HereInputs */
/** @typedef {{}} Cv_Suggest_EmojiInputs */
/** @typedef {{}} Cv_Suggest_LinksInputs */
/** @typedef {{}} Cv_Suggest_PeopleInputs */
/** @typedef {{ max: NonNullable<unknown> }} Cv_Too_LongInputs */
/** @typedef {{}} Cv_TopicInputs */
/** @typedef {{}} Cv_Topic_MenuInputs */
/** @typedef {{}} Cv_Topic_NameInputs */
/** @typedef {{}} Cv_Topic_Name_PlaceholderInputs */
/** @typedef {{}} Cv_TopicsInputs */
/** @typedef {{}} Cv_Topics_EmptyInputs */
/** @typedef {{}} Cv_Topics_None_MatchInputs */
/** @typedef {{}} Cv_Topics_StartInputs */
/** @typedef {{}} Cv_UnpinInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cv_Unpin_LabelInputs */
/** @typedef {{}} Cv_Unread_DotInputs */
/** @typedef {{}} Desktop_Client_Not_AllowedInputs */
/** @typedef {{}} Desktop_Scope_MissingInputs */
/** @typedef {{}} Desktop_Token_ExpiredInputs */
/** @typedef {{}} Desktop_Token_InvalidInputs */
/** @typedef {{}} Desktop_Token_MissingInputs */
/** @typedef {{}} Desktop_Token_RevokedInputs */
/** @typedef {{}} Desktop_WaitlistedInputs */
/** @typedef {{}} Issues_ActivityInputs */
/** @typedef {{}} Issues_Activity_Assignee_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Assignee_SetInputs */
/** @typedef {{}} Issues_Activity_CreatedInputs */
/** @typedef {{}} Issues_Activity_Cycle_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Cycle_SetInputs */
/** @typedef {{}} Issues_Activity_Due_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Due_SetInputs */
/** @typedef {{ label: NonNullable<unknown> }} Issues_Activity_Label_AddedInputs */
/** @typedef {{ label: NonNullable<unknown> }} Issues_Activity_Label_RemovedInputs */
/** @typedef {{ text: NonNullable<unknown> }} Issues_Activity_LineInputs */
/** @typedef {{}} Issues_Activity_Milestone_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Milestone_SetInputs */
/** @typedef {{}} Issues_Activity_Project_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Project_SetInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_StateInputs */
/** @typedef {{}} Issues_Activity_Team_ClearInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_Team_SetInputs */
/** @typedef {{ to: NonNullable<unknown> }} Issues_Activity_TitleInputs */
/** @typedef {{}} Issues_Add_LabelInputs */
/** @typedef {{}} Issues_Ai_MemoInputs */
/** @typedef {{}} Issues_AllInputs */
/** @typedef {{}} Issues_CancelInputs */
/** @typedef {{}} Issues_Cannot_UndoInputs */
/** @typedef {{}} Issues_Change_AssigneeInputs */
/** @typedef {{}} Issues_Change_CycleInputs */
/** @typedef {{}} Issues_Change_DueInputs */
/** @typedef {{}} Issues_Change_MilestoneInputs */
/** @typedef {{}} Issues_Change_ProjectInputs */
/** @typedef {{}} Issues_Change_SpaceInputs */
/** @typedef {{}} Issues_Change_StateInputs */
/** @typedef {{}} Issues_Change_Target_DateInputs */
/** @typedef {{}} Issues_Change_TeamInputs */
/** @typedef {{}} Issues_Choose_MilestoneInputs */
/** @typedef {{}} Issues_Choose_Team_FirstInputs */
/** @typedef {{}} Issues_Clear_DueInputs */
/** @typedef {{}} Issues_CloseInputs */
/** @typedef {{}} Issues_Col_AssigneeInputs */
/** @typedef {{}} Issues_Col_DueInputs */
/** @typedef {{}} Issues_Col_NameInputs */
/** @typedef {{}} Issues_Col_ProjectInputs */
/** @typedef {{}} Issues_Col_SpaceInputs */
/** @typedef {{}} Issues_Col_StateInputs */
/** @typedef {{}} Issues_Col_UpdatedInputs */
/** @typedef {{}} Issues_Comment_Edit_LabelInputs */
/** @typedef {{}} Issues_Comment_FailedInputs */
/** @typedef {{}} Issues_Comment_LabelInputs */
/** @typedef {{}} Issues_Comment_MenuInputs */
/** @typedef {{}} Issues_Comment_PlaceholderInputs */
/** @typedef {{ excerpt: NonNullable<unknown> }} Issues_Comment_Remove_TitleInputs */
/** @typedef {{}} Issues_CommentsInputs */
/** @typedef {{}} Issues_CreateInputs */
/** @typedef {{}} Issues_Create_FailedInputs */
/** @typedef {{}} Issues_Create_HintInputs */
/** @typedef {{}} Issues_Cycle_Active_TagInputs */
/** @typedef {{}} Issues_Cycle_Add_NextInputs */
/** @typedef {{ n: NonNullable<unknown> }} Issues_Cycle_Days_LeftInputs */
/** @typedef {{}} Issues_Cycle_Done_TagInputs */
/** @typedef {{}} Issues_Cycle_EmptyInputs */
/** @typedef {{}} Issues_Cycle_LengthInputs */
/** @typedef {{}} Issues_Cycle_MenuInputs */
/** @typedef {{ left: NonNullable<unknown> }} Issues_Cycle_Meta_ActiveInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Issues_Cycle_Meta_DoneInputs */
/** @typedef {{ starts: NonNullable<unknown> }} Issues_Cycle_Meta_Not_StartedInputs */
/** @typedef {{}} Issues_Cycle_Not_FoundInputs */
/** @typedef {{}} Issues_Cycle_Planned_TagInputs */
/** @typedef {{}} Issues_Cycle_RemoveInputs */
/** @typedef {{}} Issues_Cycle_Remove_ActionInputs */
/** @typedef {{}} Issues_Cycle_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown>, team: NonNullable<unknown> }} Issues_Cycle_Remove_TitleInputs */
/** @typedef {{ starts: NonNullable<unknown>, pct: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Cycle_SubInputs */
/** @typedef {{ starts: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Cycle_Sub_PlannedInputs */
/** @typedef {{}} Issues_Cycles_EmptyInputs */
/** @typedef {{}} Issues_Cycles_None_MatchInputs */
/** @typedef {{}} Issues_Days_UnitInputs */
/** @typedef {{}} Issues_EditInputs */
/** @typedef {{}} Issues_EmptyInputs */
/** @typedef {{}} Issues_End_DateInputs */
/** @typedef {{}} Issues_Filter_SpaceInputs */
/** @typedef {{}} Issues_Filter_Space_AllInputs */
/** @typedef {{}} Issues_Filter_TeamInputs */
/** @typedef {{}} Issues_Former_MemberInputs */
/** @typedef {{}} Issues_Group_ByInputs */
/** @typedef {{}} Issues_Group_By_AssigneeInputs */
/** @typedef {{}} Issues_Group_By_ProjectInputs */
/** @typedef {{}} Issues_Group_By_StateInputs */
/** @typedef {{}} Issues_Group_By_TeamInputs */
/** @typedef {{}} Issues_Group_No_ProjectInputs */
/** @typedef {{}} Issues_Group_No_TeamInputs */
/** @typedef {{}} Issues_Load_FailedInputs */
/** @typedef {{}} Issues_Make_FirstInputs */
/** @typedef {{}} Issues_Make_ProjectInputs */
/** @typedef {{}} Issues_Make_TeamInputs */
/** @typedef {{}} Issues_MenuInputs */
/** @typedef {{}} Issues_Milestone_AddInputs */
/** @typedef {{}} Issues_Milestone_Add_RowInputs */
/** @typedef {{}} Issues_Milestone_NameInputs */
/** @typedef {{}} Issues_Milestone_Name_ExampleInputs */
/** @typedef {{}} Issues_Milestone_New_NameInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_RemoveInputs */
/** @typedef {{}} Issues_Milestone_Remove_BodyInputs */
/** @typedef {{}} Issues_Milestone_Remove_RowInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_Remove_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Milestone_RenameInputs */
/** @typedef {{}} Issues_Milestone_Row_PlaceholderInputs */
/** @typedef {{}} Issues_NarrowInputs */
/** @typedef {{}} Issues_Narrow_CyclesInputs */
/** @typedef {{}} Issues_Narrow_Cycles_PlaceholderInputs */
/** @typedef {{}} Issues_Narrow_PlaceholderInputs */
/** @typedef {{}} Issues_Narrow_ProjectsInputs */
/** @typedef {{}} Issues_Narrow_Projects_PlaceholderInputs */
/** @typedef {{}} Issues_NavInputs */
/** @typedef {{}} Issues_NewInputs */
/** @typedef {{}} Issues_New_ProjectInputs */
/** @typedef {{}} Issues_New_TeamInputs */
/** @typedef {{}} Issues_New_Team_Cycle_DaysInputs */
/** @typedef {{}} Issues_New_Team_Name_PlaceholderInputs */
/** @typedef {{}} Issues_New_Team_NoteInputs */
/** @typedef {{}} Issues_No_ActivityInputs */
/** @typedef {{}} Issues_No_CycleInputs */
/** @typedef {{}} Issues_No_DueInputs */
/** @typedef {{}} Issues_No_MilestoneInputs */
/** @typedef {{}} Issues_No_PermissionInputs */
/** @typedef {{}} Issues_No_Permission_ProjectInputs */
/** @typedef {{}} Issues_No_Permission_TeamInputs */
/** @typedef {{}} Issues_No_ProjectInputs */
/** @typedef {{}} Issues_No_SpaceInputs */
/** @typedef {{}} Issues_No_Space_ProjectInputs */
/** @typedef {{}} Issues_No_Space_TeamInputs */
/** @typedef {{}} Issues_No_TeamInputs */
/** @typedef {{}} Issues_NoneInputs */
/** @typedef {{}} Issues_None_MatchInputs */
/** @typedef {{}} Issues_Not_FoundInputs */
/** @typedef {{}} Issues_Not_SetInputs */
/** @typedef {{}} Issues_NoteInputs */
/** @typedef {{}} Issues_Note_New_PlaceholderInputs */
/** @typedef {{}} Issues_Note_PlaceholderInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Issues_Progress_DoneInputs */
/** @typedef {{}} Issues_Project_CreateInputs */
/** @typedef {{}} Issues_Project_Create_FailedInputs */
/** @typedef {{}} Issues_Project_DoneInputs */
/** @typedef {{ count: NonNullable<unknown> }} Issues_Project_Issue_CountInputs */
/** @typedef {{}} Issues_Project_MenuInputs */
/** @typedef {{}} Issues_Project_NameInputs */
/** @typedef {{}} Issues_Project_Name_PlaceholderInputs */
/** @typedef {{}} Issues_Project_Not_FoundInputs */
/** @typedef {{}} Issues_Project_Note_New_PlaceholderInputs */
/** @typedef {{}} Issues_Project_Note_PlaceholderInputs */
/** @typedef {{ pct: NonNullable<unknown> }} Issues_Project_Pct_TargetInputs */
/** @typedef {{}} Issues_Project_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Issues_Project_Remove_TitleInputs */
/** @typedef {{}} Issues_Project_ReopenInputs */
/** @typedef {{ pct: NonNullable<unknown>, due: NonNullable<unknown>, teams: NonNullable<unknown> }} Issues_Project_SubInputs */
/** @typedef {{ pct: NonNullable<unknown>, due: NonNullable<unknown>, count: NonNullable<unknown> }} Issues_Project_SummaryInputs */
/** @typedef {{}} Issues_Projects_EmptyInputs */
/** @typedef {{}} Issues_Projects_None_DoneInputs */
/** @typedef {{}} Issues_Projects_None_MatchInputs */
/** @typedef {{}} Issues_Projects_StateInputs */
/** @typedef {{}} Issues_Prop_AssigneeInputs */
/** @typedef {{}} Issues_Prop_CycleInputs */
/** @typedef {{}} Issues_Prop_DueInputs */
/** @typedef {{}} Issues_Prop_LabelsInputs */
/** @typedef {{}} Issues_Prop_MilestoneInputs */
/** @typedef {{}} Issues_Prop_ProjectInputs */
/** @typedef {{}} Issues_Prop_StateInputs */
/** @typedef {{}} Issues_Prop_TeamInputs */
/** @typedef {{}} Issues_Range_SepInputs */
/** @typedef {{}} Issues_ReloadInputs */
/** @typedef {{}} Issues_Reload_NeededInputs */
/** @typedef {{}} Issues_RemoveInputs */
/** @typedef {{}} Issues_Remove_BodyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Issues_Remove_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Issues_Remove_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Issues_Remove_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Issues_Row_MenuInputs */
/** @typedef {{}} Issues_SaveInputs */
/** @typedef {{}} Issues_Save_FailedInputs */
/** @typedef {{ state: NonNullable<unknown> }} Issues_Set_StateInputs */
/** @typedef {{}} Issues_SomeoneInputs */
/** @typedef {{}} Issues_Start_DateInputs */
/** @typedef {{ date: NonNullable<unknown> }} Issues_Starts_OnInputs */
/** @typedef {{}} Issues_State_DoingInputs */
/** @typedef {{}} Issues_State_DoneInputs */
/** @typedef {{}} Issues_State_OpenInputs */
/** @typedef {{}} Issues_State_ReviewInputs */
/** @typedef {{}} Issues_Tab_CyclesInputs */
/** @typedef {{}} Issues_Tab_IssuesInputs */
/** @typedef {{}} Issues_Tab_ProjectsInputs */
/** @typedef {{}} Issues_Tab_UpcomingInputs */
/** @typedef {{}} Issues_TabsInputs */
/** @typedef {{}} Issues_Target_DateInputs */
/** @typedef {{}} Issues_Team_CreateInputs */
/** @typedef {{}} Issues_Team_Create_FailedInputs */
/** @typedef {{}} Issues_Team_NameInputs */
/** @typedef {{}} Issues_Team_SettingsInputs */
/** @typedef {{}} Issues_Teams_EmptyInputs */
/** @typedef {{ n: NonNullable<unknown> }} Issues_Time_Days_AgoInputs */
/** @typedef {{ time: NonNullable<unknown> }} Issues_Time_YesterdayInputs */
/** @typedef {{}} Issues_Title_LabelInputs */
/** @typedef {{}} Issues_Title_PlaceholderInputs */
/** @typedef {{ max: NonNullable<unknown> }} Issues_Too_LongInputs */
/** @typedef {{}} Issues_UnassignedInputs */
/** @typedef {{}} Issues_Upcoming_EmptyInputs */
/** @typedef {{}} Mail_Approved_Line_BodyInputs */
/** @typedef {{}} Mail_Approved_SubjectInputs */
/** @typedef {{ otp: NonNullable<unknown> }} Mail_Sign_In_Code_Line_CodeInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Mail_Sign_In_Code_Line_ExpiresInputs */
/** @typedef {{}} Mail_Sign_In_Code_Line_IgnoreInputs */
/** @typedef {{}} Mail_Sign_In_Code_SubjectInputs */
/** @typedef {{ email: NonNullable<unknown> }} Mail_Waitlist_Joined_Line_BodyInputs */
/** @typedef {{}} Mail_Waitlist_Joined_SubjectInputs */
/** @typedef {{}} Publish_ArchivedInputs */
/** @typedef {{}} Publish_Kind_ChatInputs */
/** @typedef {{}} Publish_Kind_MemberInputs */
/** @typedef {{}} Publish_Kind_MessageInputs */
/** @typedef {{}} Publish_Kind_OtherInputs */
/** @typedef {{}} Publish_Kind_Private_PageInputs */
/** @typedef {{}} Publish_Made_WithInputs */
/** @typedef {{}} Publish_Slide_ControlsInputs */
/** @typedef {{}} Publish_Slide_Exit_FullscreenInputs */
/** @typedef {{}} Publish_Slide_FullscreenInputs */
/** @typedef {{}} Publish_Slide_NextInputs */
/** @typedef {{}} Publish_Slide_PrevInputs */
/** @typedef {{}} Publish_UnavailableInputs */
/** @typedef {{ date: NonNullable<unknown> }} Publish_Updated_AtInputs */
/** @typedef {{ device: NonNullable<unknown> }} Push_App_DeniedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Push_App_LabelInputs */
/** @typedef {{}} Push_App_Open_SettingsInputs */
/** @typedef {{}} Push_BlockedInputs */
/** @typedef {{ when: NonNullable<unknown> }} Push_Delivered_AtInputs */
/** @typedef {{}} Push_Desktop_AppInputs */
/** @typedef {{}} Push_Desktop_BlockedInputs */
/** @typedef {{}} Push_Desktop_Open_SettingsInputs */
/** @typedef {{}} Push_Desktop_UnsignedInputs */
/** @typedef {{}} Push_DestinationsInputs */
/** @typedef {{}} Push_Hub_SealedInputs */
/** @typedef {{}} Push_Ios_Add_To_HomeInputs */
/** @typedef {{}} Push_Not_DeliveredInputs */
/** @typedef {{}} Push_Not_SentInputs */
/** @typedef {{}} Push_Other_DeviceInputs */
/** @typedef {{}} Push_ReceiveInputs */
/** @typedef {{}} Push_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_Remove_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Push_RemovedInputs */
/** @typedef {{}} Push_Send_TestInputs */
/** @typedef {{}} Push_SentInputs */
/** @typedef {{}} Push_Subscribe_FailedInputs */
/** @typedef {{}} Push_Test_FailedInputs */
/** @typedef {{}} Push_This_DeviceInputs */
/** @typedef {{}} Push_UnavailableInputs */
/** @typedef {{}} Push_Unsubscribe_FailedInputs */
/** @typedef {{}} Push_UnsupportedInputs */
/** @typedef {{}} Sandboxes_Admin_AllowInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_By_EmailInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_By_Email_NoteInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_DevInputs */
/** @typedef {{}} Sandboxes_Admin_Allow_FailedInputs */
/** @typedef {{}} Sandboxes_Admin_Col_AllowedInputs */
/** @typedef {{}} Sandboxes_Admin_Col_EmailInputs */
/** @typedef {{}} Sandboxes_Admin_Col_KindInputs */
/** @typedef {{}} Sandboxes_Admin_Col_StateInputs */
/** @typedef {{}} Sandboxes_Admin_DescriptionInputs */
/** @typedef {{}} Sandboxes_Admin_Email_LabelInputs */
/** @typedef {{}} Sandboxes_Admin_EmptyInputs */
/** @typedef {{}} Sandboxes_Admin_Kind_DevInputs */
/** @typedef {{}} Sandboxes_Admin_Kind_GeneralInputs */
/** @typedef {{ time: NonNullable<unknown> }} Sandboxes_Admin_Last_ActiveInputs */
/** @typedef {{}} Sandboxes_Admin_Memory_NoteInputs */
/** @typedef {{ used: NonNullable<unknown>, budget: NonNullable<unknown> }} Sandboxes_Admin_Memory_UsageInputs */
/** @typedef {{}} Sandboxes_Admin_Not_CreatedInputs */
/** @typedef {{}} Sandboxes_Admin_RevokeInputs */
/** @typedef {{ label: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Confirm_DevInputs */
/** @typedef {{ label: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Confirm_GeneralInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Failed_DevInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Failed_GeneralInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Label_DevInputs */
/** @typedef {{ email: NonNullable<unknown> }} Sandboxes_Admin_Revoke_Label_GeneralInputs */
/** @typedef {{ state: NonNullable<unknown> }} Sandboxes_Admin_Revoking_StateInputs */
/** @typedef {{}} Sandboxes_Admin_TitleInputs */
/** @typedef {{}} Sandboxes_Error_CollisionInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Delete_TimeoutInputs */
/** @typedef {{}} Sandboxes_Error_K8sInputs */
/** @typedef {{}} Sandboxes_Error_No_Dev_ImageInputs */
/** @typedef {{ code: NonNullable<unknown> }} Sandboxes_Error_OtherInputs */
/** @typedef {{}} Sandboxes_Error_Profile_MismatchInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Start_TimeoutInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_Stop_TimeoutInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Sandboxes_Error_UnreachableInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_AsleepInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_DeletingInputs */
/** @typedef {{ name: NonNullable<unknown>, error: NonNullable<unknown> }} Sandboxes_Line_ErrorInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_PreparingInputs */
/** @typedef {{ name: NonNullable<unknown>, n: NonNullable<unknown> }} Sandboxes_Line_QueuedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Line_WakingInputs */
/** @typedef {{}} Sandboxes_Menu_PreviewsInputs */
/** @typedef {{}} Sandboxes_Name_DevInputs */
/** @typedef {{}} Sandboxes_Name_GeneralInputs */
/** @typedef {{}} Sandboxes_Preview_ForbiddenInputs */
/** @typedef {{}} Sandboxes_Preview_Open_FailedInputs */
/** @typedef {{}} Sandboxes_Preview_OpeningInputs */
/** @typedef {{}} Sandboxes_Previews_DescriptionInputs */
/** @typedef {{}} Sandboxes_Previews_EmptyInputs */
/** @typedef {{ time: NonNullable<unknown> }} Sandboxes_Previews_Last_SeenInputs */
/** @typedef {{}} Sandboxes_Previews_None_RunningInputs */
/** @typedef {{}} Sandboxes_Previews_Status_ConflictInputs */
/** @typedef {{}} Sandboxes_Previews_Status_FailedInputs */
/** @typedef {{}} Sandboxes_Previews_Status_MissingInputs */
/** @typedef {{}} Sandboxes_Previews_Status_RunningInputs */
/** @typedef {{}} Sandboxes_Previews_StopInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Sandboxes_Previews_Stop_OfflineInputs */
/** @typedef {{}} Sandboxes_Previews_StoppingInputs */
/** @typedef {{}} Sandboxes_Previews_TitleInputs */
/** @typedef {{}} Sandboxes_Status_AsleepInputs */
/** @typedef {{}} Sandboxes_Status_DeletingInputs */
/** @typedef {{}} Sandboxes_Status_ErrorInputs */
/** @typedef {{}} Sandboxes_Status_PreparingInputs */
/** @typedef {{}} Sandboxes_Status_QueuedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Sandboxes_Status_Queued_AtInputs */
/** @typedef {{}} Sandboxes_Status_RunningInputs */
/** @typedef {{}} Sandboxes_Status_WakingInputs */
/** @typedef {{}} Vc_CallsInputs */
/** @typedef {{}} Vc_CancelInputs */
/** @typedef {{}} Vc_Close_DisabledInputs */
/** @typedef {{}} Vc_Close_EndedInputs */
/** @typedef {{}} Vc_Close_FullInputs */
/** @typedef {{}} Vc_Close_Not_FoundInputs */
/** @typedef {{}} Vc_Close_ReplacedInputs */
/** @typedef {{}} Vc_Closed_RejoinInputs */
/** @typedef {{}} Vc_Conn_ClosedInputs */
/** @typedef {{}} Vc_Conn_ConnectedInputs */
/** @typedef {{}} Vc_Conn_ConnectingInputs */
/** @typedef {{}} Vc_Conn_FailedInputs */
/** @typedef {{}} Vc_Conn_UnstableInputs */
/** @typedef {{}} Vc_Denoise_LoadingInputs */
/** @typedef {{}} Vc_Denoise_OffInputs */
/** @typedef {{}} Vc_Denoise_OnInputs */
/** @typedef {{}} Vc_Denoise_UnavailableInputs */
/** @typedef {{ elapsed: NonNullable<unknown> }} Vc_ElapsedInputs */
/** @typedef {{}} Vc_EmptyInputs */
/** @typedef {{}} Vc_EndInputs */
/** @typedef {{}} Vc_End_FailedInputs */
/** @typedef {{}} Vc_Ended_MarkInputs */
/** @typedef {{ when: NonNullable<unknown>, duration: NonNullable<unknown>, people: NonNullable<unknown> }} Vc_Ended_SubInputs */
/** @typedef {{}} Vc_FilterInputs */
/** @typedef {{}} Vc_Filter_AllInputs */
/** @typedef {{}} Vc_Filter_EndedInputs */
/** @typedef {{}} Vc_Filter_LiveInputs */
/** @typedef {{}} Vc_JoinInputs */
/** @typedef {{}} Vc_Join_Prepare_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Vc_Joined_AriaInputs */
/** @typedef {{}} Vc_LeaveInputs */
/** @typedef {{}} Vc_Live_MarkInputs */
/** @typedef {{}} Vc_Load_FailedInputs */
/** @typedef {{}} Vc_Mic_DeniedInputs */
/** @typedef {{ min: NonNullable<unknown> }} Vc_MinutesInputs */
/** @typedef {{}} Vc_MuteInputs */
/** @typedef {{}} Vc_MutedInputs */
/** @typedef {{}} Vc_NarrowInputs */
/** @typedef {{}} Vc_Narrow_TitleInputs */
/** @typedef {{}} Vc_New_CallInputs */
/** @typedef {{}} Vc_New_NoteInputs */
/** @typedef {{}} Vc_No_SpaceInputs */
/** @typedef {{}} Vc_NobodyInputs */
/** @typedef {{}} Vc_None_MatchInputs */
/** @typedef {{}} Vc_Not_FoundInputs */
/** @typedef {{}} Vc_Note_EndedInputs */
/** @typedef {{}} Vc_Note_LiveInputs */
/** @typedef {{}} Vc_Own_ScreenInputs */
/** @typedef {{ count: NonNullable<unknown> }} Vc_PeopleInputs */
/** @typedef {{}} Vc_Play_AudioInputs */
/** @typedef {{}} Vc_ReconnectingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Vc_Screen_OfInputs */
/** @typedef {{}} Vc_Self_SuffixInputs */
/** @typedef {{}} Vc_Share_ScreenInputs */
/** @typedef {{}} Vc_SharingInputs */
/** @typedef {{}} Vc_Space_LabelInputs */
/** @typedef {{}} Vc_StartInputs */
/** @typedef {{}} Vc_Start_FailedInputs */
/** @typedef {{}} Vc_Stop_SharingInputs */
/** @typedef {{}} Vc_Title_AriaInputs */
/** @typedef {{}} Vc_Title_LabelInputs */
/** @typedef {{}} Vc_Title_PlaceholderInputs */
/** @typedef {{}} Vc_To_ListInputs */
/** @typedef {{}} Vc_Unknown_MemberInputs */
/** @typedef {{}} Vc_UnmuteInputs */
/** @typedef {{}} Vc_Waiting_VideoInputs */
/** @typedef {{}} Wd_Col_SpaceInputs */
/** @typedef {{}} Wd_DatasetsInputs */
/** @typedef {{}} Wd_Datasets_BackInputs */
/** @typedef {{}} Wd_Datasets_CreateInputs */
/** @typedef {{}} Wd_Datasets_Create_FailedInputs */
/** @typedef {{}} Wd_Datasets_EmptyInputs */
/** @typedef {{}} Wd_Datasets_Load_FailedInputs */
/** @typedef {{}} Wd_Datasets_NewInputs */
/** @typedef {{}} Wd_Datasets_New_NoteInputs */
/** @typedef {{}} Wd_Datasets_None_MatchInputs */
/** @typedef {{ count: NonNullable<unknown> }} Wd_Datasets_RowsInputs */
/** @typedef {{}} Wd_Datasets_SpaceInputs */
/** @typedef {{}} Wd_Datasets_Space_EmptyInputs */
/** @typedef {{}} Wd_Datasets_TitleInputs */
/** @typedef {{}} Wd_EmptyInputs */
/** @typedef {{}} Wd_Load_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Move_FailedInputs */
/** @typedef {{}} Wd_Move_HintInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Move_TitleInputs */
/** @typedef {{}} Wd_NavInputs */
/** @typedef {{}} Wd_New_InInputs */
/** @typedef {{}} Wd_No_SpaceInputs */
/** @typedef {{}} Wd_None_MatchInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Pin_FailedInputs */
/** @typedef {{}} Wd_ReleaseInputs */
/** @typedef {{}} Wd_Release_ActionInputs */
/** @typedef {{}} Wd_Release_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Release_FailedInputs */
/** @typedef {{}} Wd_Release_No_SpaceInputs */
/** @typedef {{}} Wd_Release_NoneInputs */
/** @typedef {{}} Wd_Release_SpaceInputs */
/** @typedef {{ title: NonNullable<unknown> }} Wd_Release_TitleInputs */
/** @typedef {{}} Wd_Release_WorkspaceInputs */
/** @typedef {{ title: NonNullable<unknown>, workspace: NonNullable<unknown> }} Wd_ReleasedInputs */
/** @typedef {{}} Wd_Space_EmptyInputs */
/** @typedef {{}} Web_Admin_DescriptionInputs */
/** @typedef {{}} Web_Admin_TitleInputs */
/** @typedef {{}} Web_Admin_Waitlist_ApproveInputs */
/** @typedef {{}} Web_Admin_Waitlist_Approve_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_Approved_DoneInputs */
/** @typedef {{}} Web_Admin_Waitlist_ClearInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_EmailInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_JoinedInputs */
/** @typedef {{}} Web_Admin_Waitlist_Col_ViaInputs */
/** @typedef {{}} Web_Admin_Waitlist_Confirm_ApproveInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_Confirm_TextInputs */
/** @typedef {{}} Web_Admin_Waitlist_DescriptionInputs */
/** @typedef {{}} Web_Admin_Waitlist_EmptyInputs */
/** @typedef {{}} Web_Admin_Waitlist_Select_AllInputs */
/** @typedef {{ count: NonNullable<unknown> }} Web_Admin_Waitlist_SelectedInputs */
/** @typedef {{}} Web_Admin_Waitlist_TitleInputs */
/** @typedef {{}} Web_Admin_Waitlist_ToolbarInputs */
/** @typedef {{}} Web_Admin_Waitlist_Via_EmailInputs */
/** @typedef {{}} Web_App_Update_LoadInputs */
/** @typedef {{}} Web_BannedInputs */
/** @typedef {{}} Web_Captcha_FailedInputs */
/** @typedef {{}} Web_Home_IconInputs */
/** @typedef {{}} Web_Home_Icon_BlackInputs */
/** @typedef {{}} Web_Home_Icon_GreenInputs */
/** @typedef {{}} Web_Home_Icon_Ground_BlackInputs */
/** @typedef {{}} Web_Home_Icon_Ground_WhiteInputs */
/** @typedef {{}} Web_Home_Icon_InkInputs */
/** @typedef {{}} Web_Home_Icon_NoteInputs */
/** @typedef {{}} Web_Home_Icon_PurpleInputs */
/** @typedef {{}} Web_Home_Icon_StandardInputs */
/** @typedef {{}} Web_Home_Icon_VermilionInputs */
/** @typedef {{}} Web_Home_Icon_WhiteInputs */
/** @typedef {{}} Web_Hub_AllowInputs */
/** @typedef {{}} Web_Hub_Code_LabelInputs */
/** @typedef {{}} Web_Hub_Code_NextInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Hub_ConnectingInputs */
/** @typedef {{}} Web_Hub_DeniedInputs */
/** @typedef {{}} Web_Hub_DenyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Hub_Desktop_ConnectingInputs */
/** @typedef {{}} Web_Hub_Desktop_DeniedInputs */
/** @typedef {{}} Web_Hub_Desktop_DoneInputs */
/** @typedef {{}} Web_Hub_Desktop_WhatInputs */
/** @typedef {{}} Web_Hub_DoneInputs */
/** @typedef {{}} Web_Hub_FailedInputs */
/** @typedef {{}} Web_Hub_Not_FoundInputs */
/** @typedef {{}} Web_Hub_Pair_PcInputs */
/** @typedef {{}} Web_Hub_Pair_PhoneInputs */
/** @typedef {{}} Web_Hub_Pair_TitleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Web_Hub_Started_AtInputs */
/** @typedef {{ place: NonNullable<unknown> }} Web_Hub_Started_FromInputs */
/** @typedef {{}} Web_Hub_TitleInputs */
/** @typedef {{}} Web_Hub_Type_CodeInputs */
/** @typedef {{}} Web_Hub_WarningInputs */
/** @typedef {{}} Web_Hub_WhatInputs */
/** @typedef {{}} Web_Load_FailedInputs */
/** @typedef {{}} Web_Mail_FailedInputs */
/** @typedef {{}} Web_Me_Moving_BodyInputs */
/** @typedef {{}} Web_Me_Moving_Open_HereInputs */
/** @typedef {{}} Web_Me_Moving_TitleInputs */
/** @typedef {{ hub: NonNullable<unknown> }} Web_Me_On_Hub_BodyInputs */
/** @typedef {{}} Web_Me_On_Hub_Body_UnnamedInputs */
/** @typedef {{}} Web_Me_On_Hub_TitleInputs */
/** @typedef {{}} Web_Me_Opening_HereInputs */
/** @typedef {{}} Web_Menu_AdminInputs */
/** @typedef {{}} Web_Menu_Sign_OutInputs */
/** @typedef {{}} Web_Oauth_AllowInputs */
/** @typedef {{}} Web_Oauth_Can_DoInputs */
/** @typedef {{ client: NonNullable<unknown> }} Web_Oauth_ConnectingInputs */
/** @typedef {{}} Web_Oauth_DenyInputs */
/** @typedef {{}} Web_Oauth_Desktop_WarningInputs */
/** @typedef {{ where: NonNullable<unknown> }} Web_Oauth_DestinationInputs */
/** @typedef {{}} Web_Oauth_FailedInputs */
/** @typedef {{}} Web_Oauth_Outside_FlowInputs */
/** @typedef {{}} Web_Oauth_Scope_DesktopInputs */
/** @typedef {{}} Web_Oauth_Scope_OfflineInputs */
/** @typedef {{}} Web_Oauth_Scope_ReadInputs */
/** @typedef {{}} Web_Oauth_Scope_WriteInputs */
/** @typedef {{ where: NonNullable<unknown> }} Web_Oauth_This_DeviceInputs */
/** @typedef {{}} Web_Oauth_TitleInputs */
/** @typedef {{}} Web_Oauth_UnverifiedInputs */
/** @typedef {{}} Web_Otp_ExpiredInputs */
/** @typedef {{}} Web_Otp_InvalidInputs */
/** @typedef {{}} Web_Otp_Too_ManyInputs */
/** @typedef {{}} Web_Passkey_FailedInputs */
/** @typedef {{}} Web_Passkey_LaterInputs */
/** @typedef {{}} Web_Passkey_Later_NoteInputs */
/** @typedef {{}} Web_Passkey_LeadInputs */
/** @typedef {{}} Web_Passkey_NoneInputs */
/** @typedef {{}} Web_Passkey_RegisterInputs */
/** @typedef {{}} Web_Passkey_Register_FailedInputs */
/** @typedef {{}} Web_Passkey_TitleInputs */
/** @typedef {{}} Web_Rate_LimitedInputs */
/** @typedef {{}} Web_Resend_Too_SoonInputs */
/** @typedef {{}} Web_RetryInputs */
/** @typedef {{}} Web_Settings_AppsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Allow_WorkspaceInputs */
/** @typedef {{ scopes: NonNullable<unknown>, granted: NonNullable<unknown> }} Web_Settings_Apps_App_DescriptionInputs */
/** @typedef {{}} Web_Settings_Apps_CopiedInputs */
/** @typedef {{}} Web_Settings_Apps_CopyInputs */
/** @typedef {{}} Web_Settings_Apps_DescriptionInputs */
/** @typedef {{}} Web_Settings_Apps_DisconnectInputs */
/** @typedef {{}} Web_Settings_Apps_Disconnect_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Disconnect_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Disconnect_TitleInputs */
/** @typedef {{}} Web_Settings_Apps_EmptyInputs */
/** @typedef {{}} Web_Settings_Apps_ListInputs */
/** @typedef {{}} Web_Settings_Apps_No_WorkspacesInputs */
/** @typedef {{}} Web_Settings_Apps_Not_AllowedInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_DesktopInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_OfflineInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_ReadInputs */
/** @typedef {{}} Web_Settings_Apps_Scope_WriteInputs */
/** @typedef {{}} Web_Settings_Apps_UrlInputs */
/** @typedef {{}} Web_Settings_Apps_Url_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Apps_Workspace_FailedInputs */
/** @typedef {{}} Web_Settings_Apps_WorkspacesInputs */
/** @typedef {{}} Web_Settings_Apps_Workspaces_NoteInputs */
/** @typedef {{}} Web_Settings_DescriptionInputs */
/** @typedef {{}} Web_Settings_SecurityInputs */
/** @typedef {{}} Web_Settings_Security_AddInputs */
/** @typedef {{}} Web_Settings_Security_Add_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Delete_Last_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_NamedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Web_Settings_Security_Delete_TitleInputs */
/** @typedef {{}} Web_Settings_Security_DescriptionInputs */
/** @typedef {{}} Web_Settings_Security_EmailInputs */
/** @typedef {{}} Web_Settings_Security_Email_NoteInputs */
/** @typedef {{}} Web_Settings_Security_GoogleInputs */
/** @typedef {{}} Web_Settings_Security_Google_LinkInputs */
/** @typedef {{}} Web_Settings_Security_Google_Link_FailedInputs */
/** @typedef {{}} Web_Settings_Security_Google_LinkedInputs */
/** @typedef {{}} Web_Settings_Security_Google_Not_ConfiguredInputs */
/** @typedef {{}} Web_Settings_Security_Google_NoteInputs */
/** @typedef {{}} Web_Settings_Security_PasskeysInputs */
/** @typedef {{}} Web_Settings_Security_Passkeys_NoteInputs */
/** @typedef {{ date: NonNullable<unknown> }} Web_Settings_Security_Registered_OnInputs */
/** @typedef {{}} Web_Settings_Security_UnnamedInputs */
/** @typedef {{}} Web_Settings_TitleInputs */
/** @typedef {{}} Web_Signin_Code_LabelInputs */
/** @typedef {{ email: NonNullable<unknown>, minutes: NonNullable<unknown> }} Web_Signin_Code_ReusedInputs */
/** @typedef {{ email: NonNullable<unknown>, minutes: NonNullable<unknown> }} Web_Signin_Code_SentInputs */
/** @typedef {{}} Web_Signin_ContinueInputs */
/** @typedef {{}} Web_Signin_Email_HintInputs */
/** @typedef {{}} Web_Signin_Email_InvalidInputs */
/** @typedef {{}} Web_Signin_Email_LabelInputs */
/** @typedef {{}} Web_Signin_FailedInputs */
/** @typedef {{}} Web_Signin_GoogleInputs */
/** @typedef {{}} Web_Signin_Google_FailedInputs */
/** @typedef {{}} Web_Signin_In_App_BodyInputs */
/** @typedef {{}} Web_Signin_In_App_TitleInputs */
/** @typedef {{}} Web_Signin_Other_EmailInputs */
/** @typedef {{}} Web_Signin_PasskeyInputs */
/** @typedef {{}} Web_Signin_ResendInputs */
/** @typedef {{}} Web_Signin_ResentInputs */
/** @typedef {{}} Web_Signin_RetryInputs */
/** @typedef {{}} Web_Signin_TitleInputs */
/** @typedef {{}} Web_Trust_Approve_PcInputs */
/** @typedef {{}} Web_Trust_Approve_PhoneInputs */
/** @typedef {{}} Web_Trust_Approve_TitleInputs */
/** @typedef {{ email: NonNullable<unknown> }} Web_Waitlist_BodyInputs */
/** @typedef {{}} Web_Waitlist_SwitchInputs */
/** @typedef {{}} Web_Waitlist_TitleInputs */
/** @typedef {{}} Workspace_Default_Role_AdminInputs */
/** @typedef {{}} Workspace_Default_Space_NameInputs */
/** @typedef {{}} Workspace_Unnamed_MemberInputs */
/** @typedef {{}} Ws_CancelInputs */
/** @typedef {{}} Ws_Case_PanelInputs */
/** @typedef {{}} Ws_DeleteInputs */
/** @typedef {{}} Ws_Dock_SpacesInputs */
/** @typedef {{}} Ws_Feature_BroadcastInputs */
/** @typedef {{}} Ws_Feature_Broadcast_NoteInputs */
/** @typedef {{}} Ws_Feature_CycleInputs */
/** @typedef {{}} Ws_Feature_Cycle_NoteInputs */
/** @typedef {{}} Ws_Feature_DmInputs */
/** @typedef {{}} Ws_Feature_Dm_NoteInputs */
/** @typedef {{}} Ws_Feature_DocumentInputs */
/** @typedef {{}} Ws_Feature_Document_NoteInputs */
/** @typedef {{}} Ws_Feature_IssueInputs */
/** @typedef {{}} Ws_Feature_Issue_NoteInputs */
/** @typedef {{}} Ws_Feature_JournalInputs */
/** @typedef {{}} Ws_Feature_Journal_NoteInputs */
/** @typedef {{}} Ws_Feature_ProjectInputs */
/** @typedef {{}} Ws_Feature_Project_NoteInputs */
/** @typedef {{ feature: NonNullable<unknown> }} Ws_Feature_RequiresInputs */
/** @typedef {{}} Ws_Feature_TopicInputs */
/** @typedef {{}} Ws_Feature_Topic_NoteInputs */
/** @typedef {{}} Ws_Feature_VoiceInputs */
/** @typedef {{}} Ws_Feature_Voice_NoteInputs */
/** @typedef {{}} Ws_Features_EnabledInputs */
/** @typedef {{}} Ws_Features_McpInputs */
/** @typedef {{}} Ws_Features_Mcp_NoteInputs */
/** @typedef {{}} Ws_Features_OutsideInputs */
/** @typedef {{}} Ws_Features_PublishInputs */
/** @typedef {{}} Ws_Features_Publish_NoteInputs */
/** @typedef {{}} Ws_Features_Publish_OffInputs */
/** @typedef {{}} Ws_Features_Publish_Off_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Features_Publish_Off_TitleInputs */
/** @typedef {{}} Ws_General_IconInputs */
/** @typedef {{}} Ws_General_Icon_NoteInputs */
/** @typedef {{}} Ws_General_NameInputs */
/** @typedef {{}} Ws_General_UrlInputs */
/** @typedef {{}} Ws_General_Url_ChangeInputs */
/** @typedef {{}} Ws_General_Url_EditInputs */
/** @typedef {{}} Ws_General_Url_Edit_TitleInputs */
/** @typedef {{}} Ws_General_Url_NoteInputs */
/** @typedef {{}} Ws_Home_EmptyInputs */
/** @typedef {{}} Ws_Invite_FailedInputs */
/** @typedef {{ kind: NonNullable<unknown> }} Ws_Invite_Guest_NoteInputs */
/** @typedef {{}} Ws_Invite_JoinInputs */
/** @typedef {{}} Ws_Invite_LoadingInputs */
/** @typedef {{}} Ws_Invite_Not_FoundInputs */
/** @typedef {{}} Ws_Invite_Sign_InInputs */
/** @typedef {{}} Ws_Invite_TitleInputs */
/** @typedef {{ workspace: NonNullable<unknown> }} Ws_Invite_ToInputs */
/** @typedef {{ workspace: NonNullable<unknown> }} Ws_Invite_UnusableInputs */
/** @typedef {{}} Ws_Invites_ActiveInputs */
/** @typedef {{}} Ws_Invites_AllInputs */
/** @typedef {{}} Ws_Invites_CopiedInputs */
/** @typedef {{}} Ws_Invites_CopyInputs */
/** @typedef {{}} Ws_Invites_Copy_FailedInputs */
/** @typedef {{}} Ws_Invites_CreateInputs */
/** @typedef {{}} Ws_Invites_Create_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Invites_DaysInputs */
/** @typedef {{}} Ws_Invites_EmptyInputs */
/** @typedef {{}} Ws_Invites_ExpiredInputs */
/** @typedef {{}} Ws_Invites_ExpiresInputs */
/** @typedef {{}} Ws_Invites_FilterInputs */
/** @typedef {{}} Ws_Invites_Guest_NoteInputs */
/** @typedef {{}} Ws_Invites_Joins_AsInputs */
/** @typedef {{}} Ws_Invites_KindInputs */
/** @typedef {{}} Ws_Invites_LinkInputs */
/** @typedef {{}} Ws_Invites_ListInputs */
/** @typedef {{}} Ws_Invites_Max_UsesInputs */
/** @typedef {{}} Ws_Invites_Member_NoteInputs */
/** @typedef {{}} Ws_Invites_NeverInputs */
/** @typedef {{}} Ws_Invites_NewInputs */
/** @typedef {{}} Ws_Invites_No_ActiveInputs */
/** @typedef {{}} Ws_Invites_Not_FoundInputs */
/** @typedef {{}} Ws_Invites_RevokeInputs */
/** @typedef {{}} Ws_Invites_Revoke_FailedInputs */
/** @typedef {{}} Ws_Invites_Revoke_NoteInputs */
/** @typedef {{}} Ws_Invites_RevokedInputs */
/** @typedef {{}} Ws_Invites_RoleInputs */
/** @typedef {{}} Ws_Invites_Role_NoteInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Invites_TimesInputs */
/** @typedef {{}} Ws_Invites_UnlimitedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Invites_UntilInputs */
/** @typedef {{}} Ws_Invites_UrlInputs */
/** @typedef {{}} Ws_Invites_Url_HiddenInputs */
/** @typedef {{}} Ws_Invites_Url_NoteInputs */
/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Ws_Invites_UsageInputs */
/** @typedef {{ used: NonNullable<unknown> }} Ws_Invites_Usage_UnlimitedInputs */
/** @typedef {{}} Ws_Invites_Used_UpInputs */
/** @typedef {{}} Ws_Invites_UsesInputs */
/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Ws_Invites_Uses_OfInputs */
/** @typedef {{ used: NonNullable<unknown> }} Ws_Invites_Uses_UnlimitedInputs */
/** @typedef {{}} Ws_Invites_ValidInputs */
/** @typedef {{}} Ws_Kind_GuestInputs */
/** @typedef {{}} Ws_Kind_MemberInputs */
/** @typedef {{}} Ws_List_NarrowInputs */
/** @typedef {{}} Ws_List_Narrow_NameInputs */
/** @typedef {{}} Ws_List_No_MatchInputs */
/** @typedef {{}} Ws_Load_FailedInputs */
/** @typedef {{}} Ws_Members_AllInputs */
/** @typedef {{}} Ws_Members_BulkInputs */
/** @typedef {{}} Ws_Members_Bulk_ClearInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_Bulk_Remove_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_Bulk_Remove_TitleInputs */
/** @typedef {{}} Ws_Members_Col_JoinedInputs */
/** @typedef {{}} Ws_Members_Col_KindInputs */
/** @typedef {{}} Ws_Members_Col_Last_ActiveInputs */
/** @typedef {{}} Ws_Members_Col_NameInputs */
/** @typedef {{}} Ws_Members_Col_RegisteredInputs */
/** @typedef {{}} Ws_Members_Col_RolesInputs */
/** @typedef {{}} Ws_Members_EmptyInputs */
/** @typedef {{}} Ws_Members_FilterInputs */
/** @typedef {{}} Ws_Members_Guest_No_RolesInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Members_JoinedInputs */
/** @typedef {{}} Ws_Members_KindInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Kind_FailedInputs */
/** @typedef {{}} Ws_Members_ListInputs */
/** @typedef {{}} Ws_Members_Make_GuestInputs */
/** @typedef {{}} Ws_Members_Make_MemberInputs */
/** @typedef {{}} Ws_Members_No_MatchInputs */
/** @typedef {{}} Ws_Members_No_RolesInputs */
/** @typedef {{}} Ws_Members_Not_FoundInputs */
/** @typedef {{}} Ws_Members_OwnerInputs */
/** @typedef {{ date: NonNullable<unknown> }} Ws_Members_Owner_NoteInputs */
/** @typedef {{}} Ws_Members_RemoveInputs */
/** @typedef {{}} Ws_Members_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Remove_FailedInputs */
/** @typedef {{}} Ws_Members_Remove_LabelInputs */
/** @typedef {{}} Ws_Members_Remove_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Remove_TitleInputs */
/** @typedef {{}} Ws_Members_RolesInputs */
/** @typedef {{}} Ws_Members_Roles_AboveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_Roles_FailedInputs */
/** @typedef {{}} Ws_Members_Roles_Not_AllowedInputs */
/** @typedef {{}} Ws_Members_SearchInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_SelectInputs */
/** @typedef {{}} Ws_Members_Select_AllInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Members_SelectedInputs */
/** @typedef {{}} Ws_Members_To_Guest_BodyInputs */
/** @typedef {{}} Ws_Members_To_Guest_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Members_To_Guest_TitleInputs */
/** @typedef {{}} Ws_Members_To_Member_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_MenuInputs */
/** @typedef {{}} Ws_Menu_InviteInputs */
/** @typedef {{}} Ws_Menu_NewInputs */
/** @typedef {{}} Ws_Menu_SettingsInputs */
/** @typedef {{}} Ws_Missing_BodyInputs */
/** @typedef {{}} Ws_Missing_TitleInputs */
/** @typedef {{}} Ws_My_CasesInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_My_Cases_ChipInputs */
/** @typedef {{}} Ws_New_CreateInputs */
/** @typedef {{}} Ws_New_DescriptionInputs */
/** @typedef {{}} Ws_New_FailedInputs */
/** @typedef {{}} Ws_New_TitleInputs */
/** @typedef {{}} Ws_Perm_Emoji_CreateInputs */
/** @typedef {{}} Ws_Perm_Emoji_ManageInputs */
/** @typedef {{}} Ws_Perm_Issue_ManageInputs */
/** @typedef {{}} Ws_Perm_Member_ManageInputs */
/** @typedef {{}} Ws_Perm_Message_WriteInputs */
/** @typedef {{}} Ws_Perm_Page_WriteInputs */
/** @typedef {{}} Ws_Perm_Role_ManageInputs */
/** @typedef {{}} Ws_Perm_Space_ManageInputs */
/** @typedef {{}} Ws_Perm_Workspace_InviteInputs */
/** @typedef {{}} Ws_Perm_Workspace_ManageInputs */
/** @typedef {{}} Ws_Profile_AvatarInputs */
/** @typedef {{}} Ws_Profile_Avatar_NoteInputs */
/** @typedef {{}} Ws_Profile_Avatar_ResetInputs */
/** @typedef {{}} Ws_Profile_NameInputs */
/** @typedef {{}} Ws_Profile_Name_NoteInputs */
/** @typedef {{}} Ws_RailInputs */
/** @typedef {{}} Ws_Rail_NewInputs */
/** @typedef {{}} Ws_Roles_Above_YouInputs */
/** @typedef {{}} Ws_Roles_CreateInputs */
/** @typedef {{}} Ws_Roles_Create_FailedInputs */
/** @typedef {{}} Ws_Roles_Default_NoteInputs */
/** @typedef {{}} Ws_Roles_Default_SubInputs */
/** @typedef {{ count: NonNullable<unknown> }} Ws_Roles_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Delete_FailedInputs */
/** @typedef {{}} Ws_Roles_Delete_LabelInputs */
/** @typedef {{}} Ws_Roles_Delete_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Delete_TitleInputs */
/** @typedef {{}} Ws_Roles_ListInputs */
/** @typedef {{}} Ws_Roles_NameInputs */
/** @typedef {{}} Ws_Roles_Name_ExampleInputs */
/** @typedef {{}} Ws_Roles_NewInputs */
/** @typedef {{}} Ws_Roles_Not_AllowedInputs */
/** @typedef {{}} Ws_Roles_Not_FoundInputs */
/** @typedef {{}} Ws_Roles_NoteInputs */
/** @typedef {{}} Ws_Roles_Only_YoursInputs */
/** @typedef {{}} Ws_Roles_PermissionsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Roles_Permissions_FailedInputs */
/** @typedef {{}} Ws_Roles_PositionInputs */
/** @typedef {{}} Ws_Roles_Position_NoteInputs */
/** @typedef {{ position: NonNullable<unknown> }} Ws_Roles_Position_SubInputs */
/** @typedef {{}} Ws_Save_FailedInputs */
/** @typedef {{}} Ws_Settings_AdminInputs */
/** @typedef {{}} Ws_Settings_BackInputs */
/** @typedef {{}} Ws_Settings_FeaturesInputs */
/** @typedef {{}} Ws_Settings_Features_DescriptionInputs */
/** @typedef {{}} Ws_Settings_GeneralInputs */
/** @typedef {{}} Ws_Settings_General_DescriptionInputs */
/** @typedef {{}} Ws_Settings_Index_DescriptionInputs */
/** @typedef {{}} Ws_Settings_InvitesInputs */
/** @typedef {{}} Ws_Settings_Invites_DescriptionInputs */
/** @typedef {{}} Ws_Settings_MembersInputs */
/** @typedef {{}} Ws_Settings_Members_DescriptionInputs */
/** @typedef {{}} Ws_Settings_Not_AllowedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Settings_OfInputs */
/** @typedef {{}} Ws_Settings_PersonalInputs */
/** @typedef {{}} Ws_Settings_ProfileInputs */
/** @typedef {{}} Ws_Settings_Profile_DescriptionInputs */
/** @typedef {{}} Ws_Settings_RolesInputs */
/** @typedef {{}} Ws_Settings_Roles_DescriptionInputs */
/** @typedef {{}} Ws_Settings_SpacesInputs */
/** @typedef {{}} Ws_Settings_Spaces_DescriptionInputs */
/** @typedef {{}} Ws_Settings_TitleInputs */
/** @typedef {{}} Ws_Slug_FormatInputs */
/** @typedef {{}} Ws_Slug_ReservedInputs */
/** @typedef {{}} Ws_Slug_TakenInputs */
/** @typedef {{}} Ws_Spaces_Add_ManagerInputs */
/** @typedef {{}} Ws_Spaces_Add_MemberInputs */
/** @typedef {{}} Ws_Spaces_Anyone_NoteInputs */
/** @typedef {{}} Ws_Spaces_ArchiveInputs */
/** @typedef {{}} Ws_Spaces_Archive_LabelInputs */
/** @typedef {{}} Ws_Spaces_Archive_NoteInputs */
/** @typedef {{}} Ws_Spaces_ArchivedInputs */
/** @typedef {{}} Ws_Spaces_Archived_NoteInputs */
/** @typedef {{}} Ws_Spaces_CreateInputs */
/** @typedef {{}} Ws_Spaces_Create_FailedInputs */
/** @typedef {{}} Ws_Spaces_Create_Not_AllowedInputs */
/** @typedef {{}} Ws_Spaces_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Delete_FailedInputs */
/** @typedef {{}} Ws_Spaces_Delete_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Delete_TitleInputs */
/** @typedef {{}} Ws_Spaces_DescriptionInputs */
/** @typedef {{}} Ws_Spaces_Description_PlaceholderInputs */
/** @typedef {{}} Ws_Spaces_FeaturesInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Features_FailedInputs */
/** @typedef {{}} Ws_Spaces_ListInputs */
/** @typedef {{}} Ws_Spaces_ManagersInputs */
/** @typedef {{}} Ws_Spaces_MembersInputs */
/** @typedef {{}} Ws_Spaces_Members_NoteInputs */
/** @typedef {{}} Ws_Spaces_NameInputs */
/** @typedef {{}} Ws_Spaces_NarrowInputs */
/** @typedef {{}} Ws_Spaces_Narrow_Members_BodyInputs */
/** @typedef {{}} Ws_Spaces_Narrow_Private_BodyInputs */
/** @typedef {{ name: NonNullable<unknown>, visibility: NonNullable<unknown> }} Ws_Spaces_Narrow_TitleInputs */
/** @typedef {{}} Ws_Spaces_NewInputs */
/** @typedef {{}} Ws_Spaces_No_ManagersInputs */
/** @typedef {{}} Ws_Spaces_No_MembersInputs */
/** @typedef {{}} Ws_Spaces_Not_AllowedInputs */
/** @typedef {{}} Ws_Spaces_Not_FoundInputs */
/** @typedef {{}} Ws_Spaces_Private_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Remove_PersonInputs */
/** @typedef {{ name: NonNullable<unknown> }} Ws_Spaces_Remove_Person_FailedInputs */
/** @typedef {{}} Ws_Spaces_UnarchiveInputs */
/** @typedef {{}} Ws_Spaces_Unarchive_NoteInputs */
/** @typedef {{}} Ws_Spaces_VisibilityInputs */
/** @typedef {{}} Ws_Visibility_AnyoneInputs */
/** @typedef {{}} Ws_Visibility_MembersInputs */
/** @typedef {{}} Ws_Visibility_PrivateInputs */
import * as registry from "../registry.js"


export const auth_banned = /** @type {(inputs: Auth_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントは利用を停止されています。心当たりがなければ運営者に連絡してください`)
};

export const auth_mail_send_failed = /** @type {(inputs: Auth_Mail_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールを送れませんでした`)
};

export const auth_resend_too_soon = /** @type {(inputs: Auth_Resend_Too_SoonInputs) => LocalizedString} */ (i) => {
	const secondsPlural = registry.plural("ja", i?.seconds, {});return /** @type {LocalizedString} */ (`コードを送り直せるのは ${i?.seconds} 秒に 1 回です`)
};

export const cv_as_broadcast = /** @type {(inputs: Cv_As_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせとして出す`)
};

export const cv_broadcast = /** @type {(inputs: Cv_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせ`)
};

export const cv_broadcast_hint = /** @type {(inputs: Cv_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせは、この Space を見られる人に届きます。返信はできません。`)
};

export const cv_broadcast_no_reply = /** @type {(inputs: Cv_Broadcast_No_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせには返信できません。`)
};

export const cv_cancel = /** @type {(inputs: Cv_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

export const cv_cannot_post = /** @type {(inputs: Cv_Cannot_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この会話には書き込めません。`)
};

export const cv_col_last_message = /** @type {(inputs: Cv_Col_Last_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のメッセージ`)
};

export const cv_col_name = /** @type {(inputs: Cv_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const cv_col_space = /** @type {(inputs: Cv_Col_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const cv_col_updated = /** @type {(inputs: Cv_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新`)
};

export const cv_dm_empty = /** @type {(inputs: Cv_Dm_EmptyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} さんとの DM はまだありません。最初の発言で始まります。`)
};

export const cv_dm_empty_group = /** @type {(inputs: Cv_Dm_Empty_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.names} との DM はまだありません。最初の発言で始まります。`)
};

export const cv_dm_empty_self = /** @type {(inputs: Cv_Dm_Empty_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分だけの DM です。メモや下書きを置いておけます。`)
};

export const cv_dm_empty_unknown = /** @type {(inputs: Cv_Dm_Empty_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この DM はまだありません。最初の発言で始まります。`)
};

export const cv_dm_last = /** @type {(inputs: Cv_Dm_LastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最後は${i?.when}`)
};

export const cv_dm_members = /** @type {(inputs: Cv_Dm_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人のメンバー`)
};

export const cv_dm_menu = /** @type {(inputs: Cv_Dm_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM のメニュー`)
};

export const cv_dm_self_name = /** @type {(inputs: Cv_Dm_Self_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}(自分)`)
};

export const cv_dms = /** @type {(inputs: Cv_DmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const cv_dms_empty = /** @type {(inputs: Cv_Dms_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ DM はありません。`)
};

export const cv_dms_none_match = /** @type {(inputs: Cv_Dms_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる DM はありません。`)
};

export const cv_dms_none_unread = /** @type {(inputs: Cv_Dms_None_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未読の DM はありません。`)
};

export const cv_dms_start = /** @type {(inputs: Cv_Dms_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM を始める`)
};

export const cv_edit = /** @type {(inputs: Cv_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直す`)
};

export const cv_edit_label = /** @type {(inputs: Cv_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発言を直す`)
};

export const cv_emoji_add = /** @type {(inputs: Cv_Emoji_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`足す`)
};

export const cv_emoji_add_section = /** @type {(inputs: Cv_Emoji_Add_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加`)
};

export const cv_emoji_cannot_add = /** @type {(inputs: Cv_Emoji_Cannot_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵文字を足す権限がありません。`)
};

export const cv_emoji_choose = /** @type {(inputs: Cv_Emoji_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選ぶ`)
};

export const cv_emoji_choose_image = /** @type {(inputs: Cv_Emoji_Choose_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像を選ぶ`)
};

export const cv_emoji_empty = /** @type {(inputs: Cv_Emoji_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ絵文字はありません。`)
};

export const cv_emoji_full = /** @type {(inputs: Cv_Emoji_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`絵文字は ${i?.max} 個までです`)
};

export const cv_emoji_image = /** @type {(inputs: Cv_Emoji_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像`)
};

export const cv_emoji_image_note = /** @type {(inputs: Cv_Emoji_Image_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正方形に近い画像(${i?.kb}KB まで)`)
};

export const cv_emoji_list = /** @type {(inputs: Cv_Emoji_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧`)
};

export const cv_emoji_name = /** @type {(inputs: Cv_Emoji_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const cv_emoji_name_note = /** @type {(inputs: Cv_Emoji_Name_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英小文字・数字・_ と -`)
};

export const cv_emoji_name_rule = /** @type {(inputs: Cv_Emoji_Name_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前は英小文字・数字・_ と - の 32 字までです`)
};

export const cv_emoji_no_image = /** @type {(inputs: Cv_Emoji_No_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選んでいません`)
};

export const cv_emoji_pick_image = /** @type {(inputs: Cv_Emoji_Pick_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像を選んでください`)
};

export const cv_emoji_remove = /** @type {(inputs: Cv_Emoji_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const cv_emoji_remove_body = /** @type {(inputs: Cv_Emoji_Remove_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`発言とリアクションの :${i?.name}: は画像でなく文字で出るようになります。`)
};

export const cv_emoji_remove_label = /** @type {(inputs: Cv_Emoji_Remove_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`:${i?.name}: を削除`)
};

export const cv_emoji_remove_title = /** @type {(inputs: Cv_Emoji_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`:${i?.name}: を削除しますか?`)
};

export const cv_emoji_too_large = /** @type {(inputs: Cv_Emoji_Too_LargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`画像は ${i?.kb}KB までです`)
};

export const cv_filter = /** @type {(inputs: Cv_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込み`)
};

export const cv_filter_all = /** @type {(inputs: Cv_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

export const cv_filter_broadcasts = /** @type {(inputs: Cv_Filter_BroadcastsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お知らせ`)
};

export const cv_filter_space = /** @type {(inputs: Cv_Filter_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space で絞る`)
};

export const cv_filter_space_all = /** @type {(inputs: Cv_Filter_Space_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての Space`)
};

export const cv_filter_unread = /** @type {(inputs: Cv_Filter_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未読`)
};

export const cv_inbox = /** @type {(inputs: Cv_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

export const cv_inbox_reason_posted = /** @type {(inputs: Cv_Inbox_Reason_PostedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書いた会話`)
};

export const cv_load_failed = /** @type {(inputs: Cv_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const cv_loading_older = /** @type {(inputs: Cv_Loading_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込んでいます…`)
};

export const cv_mark_read = /** @type {(inputs: Cv_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既読にする`)
};

export const cv_me_dms = /** @type {(inputs: Cv_Me_DmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const cv_members_count = /** @type {(inputs: Cv_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`メンバー ${i?.count} 人`)
};

export const cv_members_more = /** @type {(inputs: Cv_Members_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ほか ${i?.count} 人`)
};

export const cv_mention_cannot_see = /** @type {(inputs: Cv_Mention_Cannot_SeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space を見られません`)
};

export const cv_message_menu = /** @type {(inputs: Cv_Message_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発言のメニュー`)
};

export const cv_move = /** @type {(inputs: Cv_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別の Space へ移す`)
};

export const cv_move_action = /** @type {(inputs: Cv_Move_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移す`)
};

export const cv_narrow = /** @type {(inputs: Cv_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧を絞り込む`)
};

export const cv_narrow_name = /** @type {(inputs: Cv_Narrow_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前で絞る`)
};

export const cv_narrow_title = /** @type {(inputs: Cv_Narrow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名で絞る`)
};

export const cv_new_dm = /** @type {(inputs: Cv_New_DmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい DM`)
};

export const cv_new_dm_chosen = /** @type {(inputs: Cv_New_Dm_ChosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選んだ相手`)
};

export const cv_new_dm_limit = /** @type {(inputs: Cv_New_Dm_LimitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選べるのは ${i?.max} 人までです`)
};

export const cv_new_dm_nobody = /** @type {(inputs: Cv_New_Dm_NobodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const cv_new_dm_people = /** @type {(inputs: Cv_New_Dm_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相手`)
};

export const cv_new_dm_search = /** @type {(inputs: Cv_New_Dm_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前で探す`)
};

export const cv_new_dm_start = /** @type {(inputs: Cv_New_Dm_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始める`)
};

export const cv_new_dm_unpick = /** @type {(inputs: Cv_New_Dm_UnpickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の選択を解除`)
};

export const cv_new_topic = /** @type {(inputs: Cv_New_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Topic`)
};

export const cv_new_topic_hint = /** @type {(inputs: Cv_New_Topic_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名は無くてもかまいません。無ければ最初の発言が一覧に出ます。`)
};

export const cv_new_topic_in = /** @type {(inputs: Cv_New_Topic_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書く Space`)
};

export const cv_no_description = /** @type {(inputs: Cv_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明はありません。`)
};

export const cv_no_space = /** @type {(inputs: Cv_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic を書ける Space がありません。`)
};

export const cv_not_found = /** @type {(inputs: Cv_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この会話は無いか、見られません。`)
};

export const cv_pin = /** @type {(inputs: Cv_PinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space に留める`)
};

export const cv_pin_down = /** @type {(inputs: Cv_Pin_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下へ`)
};

export const cv_pin_down_label = /** @type {(inputs: Cv_Pin_Down_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を下へ`)
};

export const cv_pin_gone = /** @type {(inputs: Cv_Pin_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見られないもの`)
};

export const cv_pin_up = /** @type {(inputs: Cv_Pin_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上へ`)
};

export const cv_pin_up_label = /** @type {(inputs: Cv_Pin_Up_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を上へ`)
};

export const cv_pins = /** @type {(inputs: Cv_PinsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留めたもの`)
};

export const cv_pins_empty = /** @type {(inputs: Cv_Pins_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留めたものはありません。`)
};

export const cv_pins_empty_can = /** @type {(inputs: Cv_Pins_Empty_CanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留めたものはありません。Topic や文書のメニューから留められます。`)
};

export const cv_post_label = /** @type {(inputs: Cv_Post_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発言`)
};

export const cv_post_placeholder = /** @type {(inputs: Cv_Post_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書いて送る`)
};

export const cv_post_placeholder_dm = /** @type {(inputs: Cv_Post_Placeholder_DmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} さんに送る`)
};

export const cv_post_placeholder_dm_group = /** @type {(inputs: Cv_Post_Placeholder_Dm_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.names} に送る`)
};

export const cv_post_placeholder_dm_self = /** @type {(inputs: Cv_Post_Placeholder_Dm_SelfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモを書く`)
};

export const cv_react = /** @type {(inputs: Cv_ReactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リアクションする`)
};

export const cv_react_none = /** @type {(inputs: Cv_React_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つかりません`)
};

export const cv_react_search = /** @type {(inputs: Cv_React_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵文字を探す`)
};

export const cv_reaction_check = /** @type {(inputs: Cv_Reaction_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認`)
};

export const cv_reaction_eye = /** @type {(inputs: Cv_Reaction_EyeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見ました`)
};

export const cv_reaction_label = /** @type {(inputs: Cv_Reaction_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.count}`)
};

export const cv_reactions = /** @type {(inputs: Cv_ReactionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リアクション`)
};

export const cv_recent_topics = /** @type {(inputs: Cv_Recent_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近の Topic`)
};

export const cv_remove = /** @type {(inputs: Cv_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const cv_remove_body = /** @type {(inputs: Cv_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この発言は「削除されました」の 1 行になり、添付とリアクションも消えます。元に戻せません。`)
};

export const cv_remove_title = /** @type {(inputs: Cv_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この発言を削除しますか?`)
};

export const cv_rename = /** @type {(inputs: Cv_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を変える`)
};

export const cv_rename_action = /** @type {(inputs: Cv_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変える`)
};

export const cv_save = /** @type {(inputs: Cv_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

export const cv_save_failed = /** @type {(inputs: Cv_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const cv_send_failed = /** @type {(inputs: Cv_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送れませんでした`)
};

export const cv_settings_emoji = /** @type {(inputs: Cv_Settings_EmojiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵文字`)
};

export const cv_settings_emoji_description = /** @type {(inputs: Cv_Settings_Emoji_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace だけで使える絵文字です。発言とリアクションで :名前: として使えます。`)
};

export const cv_settings_emoji_short = /** @type {(inputs: Cv_Settings_Emoji_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace だけで使える絵文字`)
};

export const cv_space = /** @type {(inputs: Cv_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const cv_space_missing = /** @type {(inputs: Cv_Space_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space は無いか、見られません。`)
};

export const cv_space_overview = /** @type {(inputs: Cv_Space_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space の概要`)
};

export const cv_start_here = /** @type {(inputs: Cv_Start_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space で Topic を作る`)
};

export const cv_suggest_emoji = /** @type {(inputs: Cv_Suggest_EmojiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵文字`)
};

export const cv_suggest_links = /** @type {(inputs: Cv_Suggest_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクする Topic`)
};

export const cv_suggest_people = /** @type {(inputs: Cv_Suggest_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバー`)
};

export const cv_too_long = /** @type {(inputs: Cv_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.max} 字までです`)
};

export const cv_topic = /** @type {(inputs: Cv_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic`)
};

export const cv_topic_menu = /** @type {(inputs: Cv_Topic_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topic のメニュー`)
};

export const cv_topic_name = /** @type {(inputs: Cv_Topic_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const cv_topic_name_placeholder = /** @type {(inputs: Cv_Topic_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名(無くてもよい)`)
};

export const cv_topics = /** @type {(inputs: Cv_TopicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topics`)
};

export const cv_topics_empty = /** @type {(inputs: Cv_Topics_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ Topic はありません。`)
};

export const cv_topics_none_match = /** @type {(inputs: Cv_Topics_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる Topic はありません。`)
};

export const cv_topics_start = /** @type {(inputs: Cv_Topics_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話しはじめる`)
};

export const cv_unpin = /** @type {(inputs: Cv_UnpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`留めるのをやめる`)
};

export const cv_unpin_label = /** @type {(inputs: Cv_Unpin_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を留めるのをやめる`)
};

export const cv_unread_dot = /** @type {(inputs: Cv_Unread_DotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未読あり`)
};

export const desktop_client_not_allowed = /** @type {(inputs: Desktop_Client_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリは trameria desktop として使えません`)
};

export const desktop_scope_missing = /** @type {(inputs: Desktop_Scope_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria desktop 用のサインインではありません`)
};

export const desktop_token_expired = /** @type {(inputs: Desktop_Token_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインの期限が切れました。もう一度サインインしてください`)
};

export const desktop_token_invalid = /** @type {(inputs: Desktop_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なトークンです`)
};

export const desktop_token_missing = /** @type {(inputs: Desktop_Token_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria desktop のサインインが必要です`)
};

export const desktop_token_revoked = /** @type {(inputs: Desktop_Token_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリの接続は解除されています。もう一度サインインしてください`)
};

export const desktop_waitlisted = /** @type {(inputs: Desktop_WaitlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認待ちです`)
};

export const issues_activity = /** @type {(inputs: Issues_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACTIVITY`)
};

export const issues_activity_assignee_clear = /** @type {(inputs: Issues_Activity_Assignee_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当を外した`)
};

export const issues_activity_assignee_set = /** @type {(inputs: Issues_Activity_Assignee_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`担当を ${i?.to} にした`)
};

export const issues_activity_created = /** @type {(inputs: Issues_Activity_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を作った`)
};

export const issues_activity_cycle_clear = /** @type {(inputs: Issues_Activity_Cycle_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle を外した`)
};

export const issues_activity_cycle_set = /** @type {(inputs: Issues_Activity_Cycle_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cycle を ${i?.to} にした`)
};

export const issues_activity_due_clear = /** @type {(inputs: Issues_Activity_Due_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限を外した`)
};

export const issues_activity_due_set = /** @type {(inputs: Issues_Activity_Due_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`期限を ${i?.to} にした`)
};

export const issues_activity_label_added = /** @type {(inputs: Issues_Activity_Label_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル ${i?.label} を付けた`)
};

export const issues_activity_label_removed = /** @type {(inputs: Issues_Activity_Label_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ラベル ${i?.label} を外した`)
};

export const issues_activity_line = /** @type {(inputs: Issues_Activity_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` が${i?.text}`)
};

export const issues_activity_milestone_clear = /** @type {(inputs: Issues_Activity_Milestone_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンを外した`)
};

export const issues_activity_milestone_set = /** @type {(inputs: Issues_Activity_Milestone_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マイルストーンを ${i?.to} にした`)
};

export const issues_activity_project_clear = /** @type {(inputs: Issues_Activity_Project_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を外した`)
};

export const issues_activity_project_set = /** @type {(inputs: Issues_Activity_Project_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project を ${i?.to} にした`)
};

export const issues_activity_state = /** @type {(inputs: Issues_Activity_StateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`状態を ${i?.to} に変えた`)
};

export const issues_activity_team_clear = /** @type {(inputs: Issues_Activity_Team_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team を外した`)
};

export const issues_activity_team_set = /** @type {(inputs: Issues_Activity_Team_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Team を ${i?.to} にした`)
};

export const issues_activity_title = /** @type {(inputs: Issues_Activity_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`題名を「${i?.to}」に変えた`)
};

export const issues_add_label = /** @type {(inputs: Issues_Add_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベルを足す`)
};

export const issues_ai_memo = /** @type {(inputs: Issues_Ai_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI メモ`)
};

export const issues_all = /** @type {(inputs: Issues_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

export const issues_cancel = /** @type {(inputs: Issues_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

export const issues_cannot_undo = /** @type {(inputs: Issues_Cannot_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元には戻せません。`)
};

export const issues_change_assignee = /** @type {(inputs: Issues_Change_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当を変える`)
};

export const issues_change_cycle = /** @type {(inputs: Issues_Change_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle を変える`)
};

export const issues_change_due = /** @type {(inputs: Issues_Change_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限を変える`)
};

export const issues_change_milestone = /** @type {(inputs: Issues_Change_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンを変える`)
};

export const issues_change_project = /** @type {(inputs: Issues_Change_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を変える`)
};

export const issues_change_space = /** @type {(inputs: Issues_Change_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space を変える`)
};

export const issues_change_state = /** @type {(inputs: Issues_Change_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態を変える`)
};

export const issues_change_target_date = /** @type {(inputs: Issues_Change_Target_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日を変える`)
};

export const issues_change_team = /** @type {(inputs: Issues_Change_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team を変える`)
};

export const issues_choose_milestone = /** @type {(inputs: Issues_Choose_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンを選ぶ`)
};

export const issues_choose_team_first = /** @type {(inputs: Issues_Choose_Team_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先に Team を選ぶ`)
};

export const issues_clear_due = /** @type {(inputs: Issues_Clear_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限を外す`)
};

export const issues_close = /** @type {(inputs: Issues_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

export const issues_col_assignee = /** @type {(inputs: Issues_Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当`)
};

export const issues_col_due = /** @type {(inputs: Issues_Col_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日`)
};

export const issues_col_name = /** @type {(inputs: Issues_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const issues_col_project = /** @type {(inputs: Issues_Col_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

export const issues_col_space = /** @type {(inputs: Issues_Col_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const issues_col_state = /** @type {(inputs: Issues_Col_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

export const issues_col_updated = /** @type {(inputs: Issues_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

export const issues_comment_edit_label = /** @type {(inputs: Issues_Comment_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを直す`)
};

export const issues_comment_failed = /** @type {(inputs: Issues_Comment_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを送れませんでした`)
};

export const issues_comment_label = /** @type {(inputs: Issues_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント`)
};

export const issues_comment_menu = /** @type {(inputs: Issues_Comment_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントの操作`)
};

export const issues_comment_placeholder = /** @type {(inputs: Issues_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを書く…`)
};

export const issues_comment_remove_title = /** @type {(inputs: Issues_Comment_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`コメント「${i?.excerpt}」を削除しますか?`)
};

export const issues_comments = /** @type {(inputs: Issues_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント`)
};

export const issues_create = /** @type {(inputs: Issues_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を作成`)
};

export const issues_create_failed = /** @type {(inputs: Issues_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を作れませんでした`)
};

export const issues_create_hint = /** @type {(inputs: Issues_Create_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘↵ でも作れる`)
};

export const issues_cycle_active_tag = /** @type {(inputs: Issues_Cycle_Active_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

export const issues_cycle_add_next = /** @type {(inputs: Issues_Cycle_Add_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の Cycle を足す`)
};

export const issues_cycle_days_left = /** @type {(inputs: Issues_Cycle_Days_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残 ${i?.n}日`)
};

export const issues_cycle_done_tag = /** @type {(inputs: Issues_Cycle_Done_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

export const issues_cycle_empty = /** @type {(inputs: Issues_Cycle_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Cycle にはまだ Issue が無い。Issue の Cycle から積める。`)
};

export const issues_cycle_length = /** @type {(inputs: Issues_Cycle_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle の長さ`)
};

export const issues_cycle_menu = /** @type {(inputs: Issues_Cycle_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle の操作`)
};

export const issues_cycle_meta_active = /** @type {(inputs: Issues_Cycle_Meta_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`進行中 · ${i?.left}`)
};

export const issues_cycle_meta_done = /** @type {(inputs: Issues_Cycle_Meta_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`完了 · ${i?.from}〜${i?.to}`)
};

export const issues_cycle_meta_not_started = /** @type {(inputs: Issues_Cycle_Meta_Not_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.starts} · まだ始まっていない`)
};

export const issues_cycle_not_found = /** @type {(inputs: Issues_Cycle_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle が見つかりません。URL が違うか、削除されました。`)
};

export const issues_cycle_planned_tag = /** @type {(inputs: Issues_Cycle_Planned_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

export const issues_cycle_remove = /** @type {(inputs: Issues_Cycle_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Cycle を消す`)
};

export const issues_cycle_remove_action = /** @type {(inputs: Issues_Cycle_Remove_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消す`)
};

export const issues_cycle_remove_body = /** @type {(inputs: Issues_Cycle_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入っていた Issue は残り、Cycle から外れます。元には戻せません。`)
};

export const issues_cycle_remove_title = /** @type {(inputs: Issues_Cycle_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}(${i?.team})を消しますか?`)
};

export const issues_cycle_sub = /** @type {(inputs: Issues_Cycle_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.starts} · ${i?.pct}% · ${i?.count} 件`)
};

export const issues_cycle_sub_planned = /** @type {(inputs: Issues_Cycle_Sub_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.starts} · ${i?.count} 件を予定`)
};

export const issues_cycles_empty = /** @type {(inputs: Issues_Cycles_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle はまだありません`)
};

export const issues_cycles_none_match = /** @type {(inputs: Issues_Cycles_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる Cycle はありません`)
};

export const issues_days_unit = /** @type {(inputs: Issues_Days_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日`)
};

export const issues_edit = /** @type {(inputs: Issues_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集`)
};

export const issues_empty = /** @type {(inputs: Issues_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue はまだありません`)
};

export const issues_end_date = /** @type {(inputs: Issues_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了日`)
};

export const issues_filter_space = /** @type {(inputs: Issues_Filter_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space で絞る`)
};

export const issues_filter_space_all = /** @type {(inputs: Issues_Filter_Space_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての Space`)
};

export const issues_filter_team = /** @type {(inputs: Issues_Filter_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team で絞る`)
};

export const issues_former_member = /** @type {(inputs: Issues_Former_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退会したメンバー`)
};

export const issues_group_by = /** @type {(inputs: Issues_Group_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとめ方`)
};

export const issues_group_by_assignee = /** @type {(inputs: Issues_Group_By_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当別`)
};

export const issues_group_by_project = /** @type {(inputs: Issues_Group_By_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project 別`)
};

export const issues_group_by_state = /** @type {(inputs: Issues_Group_By_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態別`)
};

export const issues_group_by_team = /** @type {(inputs: Issues_Group_By_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team 別`)
};

export const issues_group_no_project = /** @type {(inputs: Issues_Group_No_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project なし`)
};

export const issues_group_no_team = /** @type {(inputs: Issues_Group_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team なし`)
};

export const issues_load_failed = /** @type {(inputs: Issues_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const issues_make_first = /** @type {(inputs: Issues_Make_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を作る`)
};

export const issues_make_project = /** @type {(inputs: Issues_Make_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を作る`)
};

export const issues_make_team = /** @type {(inputs: Issues_Make_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team を作る`)
};

export const issues_menu = /** @type {(inputs: Issues_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue の操作`)
};

export const issues_milestone_add = /** @type {(inputs: Issues_Milestone_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ マイルストーン`)
};

export const issues_milestone_add_row = /** @type {(inputs: Issues_Milestone_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンを追加`)
};

export const issues_milestone_name = /** @type {(inputs: Issues_Milestone_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンの名前`)
};

export const issues_milestone_name_example = /** @type {(inputs: Issues_Milestone_Name_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`M4 振り返り`)
};

export const issues_milestone_new_name = /** @type {(inputs: Issues_Milestone_New_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいマイルストーンの名前`)
};

export const issues_milestone_remove = /** @type {(inputs: Issues_Milestone_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マイルストーン「${i?.name}」を削除`)
};

export const issues_milestone_remove_body = /** @type {(inputs: Issues_Milestone_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付いていた Issue は残り、マイルストーンから外れます。元には戻せません。`)
};

export const issues_milestone_remove_row = /** @type {(inputs: Issues_Milestone_Remove_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンを外す`)
};

export const issues_milestone_remove_title = /** @type {(inputs: Issues_Milestone_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マイルストーン「${i?.name}」を削除しますか?`)
};

export const issues_milestone_rename = /** @type {(inputs: Issues_Milestone_RenameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マイルストーン「${i?.name}」を改名`)
};

export const issues_milestone_row_placeholder = /** @type {(inputs: Issues_Milestone_Row_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: M1 仕様確定`)
};

export const issues_narrow = /** @type {(inputs: Issues_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を絞り込む`)
};

export const issues_narrow_cycles = /** @type {(inputs: Issues_Narrow_CyclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle を絞り込む`)
};

export const issues_narrow_cycles_placeholder = /** @type {(inputs: Issues_Narrow_Cycles_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle・Team で絞る`)
};

export const issues_narrow_placeholder = /** @type {(inputs: Issues_Narrow_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名で絞る`)
};

export const issues_narrow_projects = /** @type {(inputs: Issues_Narrow_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を絞り込む`)
};

export const issues_narrow_projects_placeholder = /** @type {(inputs: Issues_Narrow_Projects_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前で絞る`)
};

export const issues_nav = /** @type {(inputs: Issues_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

export const issues_new = /** @type {(inputs: Issues_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New issue`)
};

export const issues_new_project = /** @type {(inputs: Issues_New_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New project`)
};

export const issues_new_team = /** @type {(inputs: Issues_New_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Team`)
};

export const issues_new_team_cycle_days = /** @type {(inputs: Issues_New_Team_Cycle_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle の長さ(日)`)
};

export const issues_new_team_name_placeholder = /** @type {(inputs: Issues_New_Team_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: Web 基盤`)
};

export const issues_new_team_note = /** @type {(inputs: Issues_New_Team_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle を回す単位。作ると今日から始まる Cycle と、その先 2 本ができる。`)
};

export const issues_no_activity = /** @type {(inputs: Issues_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ動きはない`)
};

export const issues_no_cycle = /** @type {(inputs: Issues_No_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle 未設定`)
};

export const issues_no_due = /** @type {(inputs: Issues_No_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限なし`)
};

export const issues_no_milestone = /** @type {(inputs: Issues_No_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーンなし`)
};

export const issues_no_permission = /** @type {(inputs: Issues_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を作る権限がありません(issue.manage が要る)。ロールを持っている人に頼むこと。`)
};

export const issues_no_permission_project = /** @type {(inputs: Issues_No_Permission_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を作る権限がありません(issue.manage が要る)。ロールを持っている人に頼むこと。`)
};

export const issues_no_permission_team = /** @type {(inputs: Issues_No_Permission_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team を作る権限がありません(issue.manage が要る)。ロールを持っている人に頼むこと。`)
};

export const issues_no_project = /** @type {(inputs: Issues_No_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトなし`)
};

export const issues_no_space = /** @type {(inputs: Issues_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を置ける Space がありません。`)
};

export const issues_no_space_project = /** @type {(inputs: Issues_No_Space_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を置ける Space がありません。`)
};

export const issues_no_space_team = /** @type {(inputs: Issues_No_Space_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle を使える Space がありません。`)
};

export const issues_no_team = /** @type {(inputs: Issues_No_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team 未設定`)
};

export const issues_none = /** @type {(inputs: Issues_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

export const issues_none_match = /** @type {(inputs: Issues_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる Issue はありません`)
};

export const issues_not_found = /** @type {(inputs: Issues_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue が見つかりません。URL が違うか、削除されました。`)
};

export const issues_not_set = /** @type {(inputs: Issues_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未設定`)
};

export const issues_note = /** @type {(inputs: Issues_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文`)
};

export const issues_note_new_placeholder = /** @type {(inputs: Issues_Note_New_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明を書く…`)
};

export const issues_note_placeholder = /** @type {(inputs: Issues_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本文を書く…`)
};

export const issues_progress_done = /** @type {(inputs: Issues_Progress_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done}/${i?.total} 完了`)
};

export const issues_project_create = /** @type {(inputs: Issues_Project_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を作成`)
};

export const issues_project_create_failed = /** @type {(inputs: Issues_Project_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project を作れませんでした`)
};

export const issues_project_done = /** @type {(inputs: Issues_Project_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了にする`)
};

export const issues_project_issue_count = /** @type {(inputs: Issues_Project_Issue_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`· Issue ${i?.count}`)
};

export const issues_project_menu = /** @type {(inputs: Issues_Project_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project の操作`)
};

export const issues_project_name = /** @type {(inputs: Issues_Project_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project の名前`)
};

export const issues_project_name_placeholder = /** @type {(inputs: Issues_Project_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project の名前`)
};

export const issues_project_not_found = /** @type {(inputs: Issues_Project_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project が見つかりません。URL が違うか、削除されました。`)
};

export const issues_project_note_new_placeholder = /** @type {(inputs: Issues_Project_Note_New_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何をする Project か、背景や狙いを書く…`)
};

export const issues_project_note_placeholder = /** @type {(inputs: Issues_Project_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何をする Project か…`)
};

export const issues_project_pct_target = /** @type {(inputs: Issues_Project_Pct_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · 期限`)
};

export const issues_project_remove_body = /** @type {(inputs: Issues_Project_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中の Issue は残り、Project から外れます。マイルストーンは一緒に消えます。元には戻せません。`)
};

export const issues_project_remove_title = /** @type {(inputs: Issues_Project_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project「${i?.name}」を削除しますか?`)
};

export const issues_project_reopen = /** @type {(inputs: Issues_Project_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中に戻す`)
};

export const issues_project_sub = /** @type {(inputs: Issues_Project_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · ${i?.due} · Team ${i?.teams}`)
};

export const issues_project_summary = /** @type {(inputs: Issues_Project_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · 期限 ${i?.due} · Issue ${i?.count}`)
};

export const issues_projects_empty = /** @type {(inputs: Issues_Projects_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project はまだありません`)
};

export const issues_projects_none_done = /** @type {(inputs: Issues_Projects_None_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了した Project はありません`)
};

export const issues_projects_none_match = /** @type {(inputs: Issues_Projects_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる Project はありません`)
};

export const issues_projects_state = /** @type {(inputs: Issues_Projects_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態で絞る`)
};

export const issues_prop_assignee = /** @type {(inputs: Issues_Prop_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当`)
};

export const issues_prop_cycle = /** @type {(inputs: Issues_Prop_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle`)
};

export const issues_prop_due = /** @type {(inputs: Issues_Prop_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限`)
};

export const issues_prop_labels = /** @type {(inputs: Issues_Prop_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラベル`)
};

export const issues_prop_milestone = /** @type {(inputs: Issues_Prop_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイルストーン`)
};

export const issues_prop_project = /** @type {(inputs: Issues_Prop_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

export const issues_prop_state = /** @type {(inputs: Issues_Prop_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

export const issues_prop_team = /** @type {(inputs: Issues_Prop_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team`)
};

export const issues_range_sep = /** @type {(inputs: Issues_Range_SepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`〜`)
};

export const issues_reload = /** @type {(inputs: Issues_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み直す`)
};

export const issues_reload_needed = /** @type {(inputs: Issues_Reload_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリが古くなっています。読み込み直すと書けるようになります。`)
};

export const issues_remove = /** @type {(inputs: Issues_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const issues_remove_body = /** @type {(inputs: Issues_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Issue に付いたコメントと ACTIVITY も一緒に消えます。元には戻せません。`)
};

export const issues_remove_many_body = /** @type {(inputs: Issues_Remove_Many_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.names}。付いたコメントと ACTIVITY も一緒に消えます。元には戻せません。`)
};

export const issues_remove_many_title = /** @type {(inputs: Issues_Remove_Many_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の Issue を削除しますか?`)
};

export const issues_remove_title = /** @type {(inputs: Issues_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を削除しますか?`)
};

export const issues_row_menu = /** @type {(inputs: Issues_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の操作`)
};

export const issues_save = /** @type {(inputs: Issues_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

export const issues_save_failed = /** @type {(inputs: Issues_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const issues_set_state = /** @type {(inputs: Issues_Set_StateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.state}にする`)
};

export const issues_someone = /** @type {(inputs: Issues_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰か`)
};

export const issues_start_date = /** @type {(inputs: Issues_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始日`)
};

export const issues_starts_on = /** @type {(inputs: Issues_Starts_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 開始`)
};

export const issues_state_doing = /** @type {(inputs: Issues_State_DoingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中`)
};

export const issues_state_done = /** @type {(inputs: Issues_State_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了`)
};

export const issues_state_open = /** @type {(inputs: Issues_State_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未着手`)
};

export const issues_state_review = /** @type {(inputs: Issues_State_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー待ち`)
};

export const issues_tab_cycles = /** @type {(inputs: Issues_Tab_CyclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycles`)
};

export const issues_tab_issues = /** @type {(inputs: Issues_Tab_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues`)
};

export const issues_tab_projects = /** @type {(inputs: Issues_Tab_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects`)
};

export const issues_tab_upcoming = /** @type {(inputs: Issues_Tab_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

export const issues_tabs = /** @type {(inputs: Issues_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issues の一覧`)
};

export const issues_target_date = /** @type {(inputs: Issues_Target_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期日`)
};

export const issues_team_create = /** @type {(inputs: Issues_Team_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作る`)
};

export const issues_team_create_failed = /** @type {(inputs: Issues_Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team を作れませんでした`)
};

export const issues_team_name = /** @type {(inputs: Issues_Team_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const issues_team_settings = /** @type {(inputs: Issues_Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team の設定`)
};

export const issues_teams_empty = /** @type {(inputs: Issues_Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team はまだありません`)
};

export const issues_time_days_ago = /** @type {(inputs: Issues_Time_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}日前`)
};

export const issues_time_yesterday = /** @type {(inputs: Issues_Time_YesterdayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`昨日 ${i?.time}`)
};

export const issues_title_label = /** @type {(inputs: Issues_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const issues_title_placeholder = /** @type {(inputs: Issues_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue のタイトル`)
};

export const issues_too_long = /** @type {(inputs: Issues_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.max} 字までです`)
};

export const issues_unassigned = /** @type {(inputs: Issues_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未割当`)
};

export const issues_upcoming_empty = /** @type {(inputs: Issues_Upcoming_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle を待っている Issue はありません`)
};

export const mail_approved_line_body = /** @type {(inputs: Mail_Approved_Line_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ちが承認されました。次の URL からサインインできます。`)
};

export const mail_approved_subject = /** @type {(inputs: Mail_Approved_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria にサインインできるようになりました`)
};

export const mail_sign_in_code_line_code = /** @type {(inputs: Mail_Sign_In_Code_Line_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`trameria のサインインコードは ${i?.otp} です。`)
};

export const mail_sign_in_code_line_expires = /** @type {(inputs: Mail_Sign_In_Code_Line_ExpiresInputs) => LocalizedString} */ (i) => {
	const minutesPlural = registry.plural("ja", i?.minutes, {});return /** @type {LocalizedString} */ (`${i?.minutes} 分で期限が切れます。`)
};

export const mail_sign_in_code_line_ignore = /** @type {(inputs: Mail_Sign_In_Code_Line_IgnoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`心当たりがなければ、このメールは無視してください。`)
};

export const mail_sign_in_code_subject = /** @type {(inputs: Mail_Sign_In_Code_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria のサインインコード`)
};

export const mail_waitlist_joined_line_body = /** @type {(inputs: Mail_Waitlist_Joined_Line_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} が順番待ちに入りました。`)
};

export const mail_waitlist_joined_subject = /** @type {(inputs: Mail_Waitlist_Joined_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ちに登録がありました`)
};

export const publish_archived = /** @type {(inputs: Publish_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブした文書は公開できません`)
};

export const publish_kind_chat = /** @type {(inputs: Publish_Kind_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話`)
};

export const publish_kind_member = /** @type {(inputs: Publish_Kind_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバー`)
};

export const publish_kind_message = /** @type {(inputs: Publish_Kind_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発言`)
};

export const publish_kind_other = /** @type {(inputs: Publish_Kind_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参照`)
};

export const publish_kind_private_page = /** @type {(inputs: Publish_Kind_Private_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非公開の文書`)
};

export const publish_made_with = /** @type {(inputs: Publish_Made_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria で作成`)
};

export const publish_slide_controls = /** @type {(inputs: Publish_Slide_ControlsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スライドの操作`)
};

export const publish_slide_exit_fullscreen = /** @type {(inputs: Publish_Slide_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面を終える`)
};

export const publish_slide_fullscreen = /** @type {(inputs: Publish_Slide_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面`)
};

export const publish_slide_next = /** @type {(inputs: Publish_Slide_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のスライド`)
};

export const publish_slide_prev = /** @type {(inputs: Publish_Slide_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のスライド`)
};

export const publish_unavailable = /** @type {(inputs: Publish_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境ではリンクで公開できません(公開用の置き場がありません)`)
};

export const publish_updated_at = /** @type {(inputs: Publish_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終更新 ${i?.date}`)
};

export const push_app_denied = /** @type {(inputs: Push_App_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} の設定で通知が許可されていません`)
};

export const push_app_label = /** @type {(inputs: Push_App_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device}(アプリ)`)
};

export const push_app_open_settings = /** @type {(inputs: Push_App_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を開く`)
};

export const push_blocked = /** @type {(inputs: Push_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザでは通知がブロックされています。アドレスバーのサイトの設定から許可すると、ここで受け取りを始められます`)
};

export const push_delivered_at = /** @type {(inputs: Push_Delivered_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when}に届いた`)
};

export const push_desktop_app = /** @type {(inputs: Push_Desktop_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デスクトップアプリ`)
};

export const push_desktop_blocked = /** @type {(inputs: Push_Desktop_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mac の通知が許可されていません`)
};

export const push_desktop_open_settings = /** @type {(inputs: Push_Desktop_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システム設定を開く`)
};

export const push_desktop_unsigned = /** @type {(inputs: Push_Desktop_UnsignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このビルドでは mac の通知が出ません`)
};

export const push_destinations = /** @type {(inputs: Push_DestinationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`届け先`)
};

export const push_hub_sealed = /** @type {(inputs: Push_Hub_SealedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい通知があります`)
};

export const push_ios_add_to_home = /** @type {(inputs: Push_Ios_Add_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム画面に追加すると通知を受け取れます。共有ボタンから「ホーム画面に追加」を選んでください`)
};

export const push_not_delivered = /** @type {(inputs: Push_Not_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ届いていません`)
};

export const push_not_sent = /** @type {(inputs: Push_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`届けられませんでした`)
};

export const push_other_device = /** @type {(inputs: Push_Other_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他`)
};

export const push_receive = /** @type {(inputs: Push_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスで受け取る`)
};

export const push_remove = /** @type {(inputs: Push_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解除`)
};

export const push_remove_failed = /** @type {(inputs: Push_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を解除できませんでした`)
};

export const push_removed = /** @type {(inputs: Push_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を解除しました`)
};

export const push_send_test = /** @type {(inputs: Push_Send_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト送信`)
};

export const push_sent = /** @type {(inputs: Push_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスト通知を送りました`)
};

export const push_subscribe_failed = /** @type {(inputs: Push_Subscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取りを始められませんでした`)
};

export const push_test_failed = /** @type {(inputs: Push_Test_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信できませんでした`)
};

export const push_this_device = /** @type {(inputs: Push_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイス`)
};

export const push_unavailable = /** @type {(inputs: Push_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境では通知を使えません`)
};

export const push_unsubscribe_failed = /** @type {(inputs: Push_Unsubscribe_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取りを止められませんでした`)
};

export const push_unsupported = /** @type {(inputs: Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザは通知に対応していません`)
};

export const sandboxes_admin_allow = /** @type {(inputs: Sandboxes_Admin_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可`)
};

export const sandboxes_admin_allow_by_email = /** @type {(inputs: Sandboxes_Admin_Allow_By_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールで許可`)
};

export const sandboxes_admin_allow_by_email_note = /** @type {(inputs: Sandboxes_Admin_Allow_By_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria に登録済みのメールアドレス`)
};

export const sandboxes_admin_allow_dev = /** @type {(inputs: Sandboxes_Admin_Allow_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用を許可`)
};

export const sandboxes_admin_allow_failed = /** @type {(inputs: Sandboxes_Admin_Allow_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可できませんでした`)
};

export const sandboxes_admin_col_allowed = /** @type {(inputs: Sandboxes_Admin_Col_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可日`)
};

export const sandboxes_admin_col_email = /** @type {(inputs: Sandboxes_Admin_Col_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

export const sandboxes_admin_col_kind = /** @type {(inputs: Sandboxes_Admin_Col_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種類`)
};

export const sandboxes_admin_col_state = /** @type {(inputs: Sandboxes_Admin_Col_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

export const sandboxes_admin_description = /** @type {(inputs: Sandboxes_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可した人は、自分の trameria cloud を作れます。開発用は開発する人の sandbox で、一般用とは別に持てます。取り消すと、その種類の trameria cloud も消します。`)
};

export const sandboxes_admin_email_label = /** @type {(inputs: Sandboxes_Admin_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可するメールアドレス`)
};

export const sandboxes_admin_empty = /** @type {(inputs: Sandboxes_Admin_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可した人はいません`)
};

export const sandboxes_admin_kind_dev = /** @type {(inputs: Sandboxes_Admin_Kind_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用`)
};

export const sandboxes_admin_kind_general = /** @type {(inputs: Sandboxes_Admin_Kind_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般用`)
};

export const sandboxes_admin_last_active = /** @type {(inputs: Sandboxes_Admin_Last_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最後に使った ${i?.time}`)
};

export const sandboxes_admin_memory_note = /** @type {(inputs: Sandboxes_Admin_Memory_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(起きている sandbox の上限の合計。枠を超える分は順番待ち)`)
};

export const sandboxes_admin_memory_usage = /** @type {(inputs: Sandboxes_Admin_Memory_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用中 ${i?.used} GB / 枠 ${i?.budget} GB`)
};

export const sandboxes_admin_not_created = /** @type {(inputs: Sandboxes_Admin_Not_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ作っていません`)
};

export const sandboxes_admin_revoke = /** @type {(inputs: Sandboxes_Admin_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取り消す`)
};

export const sandboxes_admin_revoke_confirm_dev = /** @type {(inputs: Sandboxes_Admin_Revoke_Confirm_DevInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.label}」の開発用の許可を取り消します。その trameria cloud があれば消し、そのディスク(作業ディレクトリのファイル)とサインインも消えます。動いているプレビューも止まります。`)
};

export const sandboxes_admin_revoke_confirm_general = /** @type {(inputs: Sandboxes_Admin_Revoke_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.label}」の一般用の許可を取り消します。その trameria cloud があれば消し、そのディスク(作業ディレクトリのファイル)とサインインも消えます。`)
};

export const sandboxes_admin_revoke_failed_dev = /** @type {(inputs: Sandboxes_Admin_Revoke_Failed_DevInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} の開発用の許可を取り消せませんでした`)
};

export const sandboxes_admin_revoke_failed_general = /** @type {(inputs: Sandboxes_Admin_Revoke_Failed_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} の一般用の許可を取り消せませんでした`)
};

export const sandboxes_admin_revoke_label_dev = /** @type {(inputs: Sandboxes_Admin_Revoke_Label_DevInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} の開発用の許可を取り消す`)
};

export const sandboxes_admin_revoke_label_general = /** @type {(inputs: Sandboxes_Admin_Revoke_Label_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} の一般用の許可を取り消す`)
};

export const sandboxes_admin_revoking_state = /** @type {(inputs: Sandboxes_Admin_Revoking_StateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`取り消し中 · ${i?.state}`)
};

export const sandboxes_admin_title = /** @type {(inputs: Sandboxes_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const sandboxes_error_collision = /** @type {(inputs: Sandboxes_Error_CollisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ名前の別の sandbox があるため作れません。運営に知らせてください`)
};

export const sandboxes_error_delete_timeout = /** @type {(inputs: Sandboxes_Error_Delete_TimeoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分待っても消し終わりません。続けて消しています`)
};

export const sandboxes_error_k8s = /** @type {(inputs: Sandboxes_Error_K8sInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サーバーの環境とやりとりできませんでした。しばらくすると自動でやり直します`)
};

export const sandboxes_error_no_dev_image = /** @type {(inputs: Sandboxes_Error_No_Dev_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用のイメージが用意されていません。運営に知らせてください`)
};

export const sandboxes_error_other = /** @type {(inputs: Sandboxes_Error_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`原因が分かりません(${i?.code})`)
};

export const sandboxes_error_profile_mismatch = /** @type {(inputs: Sandboxes_Error_Profile_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種類の違う sandbox が残っているため起こせません。運営に知らせてください`)
};

export const sandboxes_error_start_timeout = /** @type {(inputs: Sandboxes_Error_Start_TimeoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分待っても起動しませんでした。しばらくすると自動でやり直します`)
};

export const sandboxes_error_stop_timeout = /** @type {(inputs: Sandboxes_Error_Stop_TimeoutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} 分待っても止まりませんでした`)
};

export const sandboxes_error_unreachable = /** @type {(inputs: Sandboxes_Error_UnreachableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`起動しましたが、${i?.minutes} 分待っても Agent が繋がりませんでした。しばらくすると自動でやり直します`)
};

export const sandboxes_line_asleep = /** @type {(inputs: Sandboxes_Line_AsleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} は休止中です。話しかけると起きます`)
};

export const sandboxes_line_deleting = /** @type {(inputs: Sandboxes_Line_DeletingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を消しています`)
};

export const sandboxes_line_error = /** @type {(inputs: Sandboxes_Line_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} がうまく動いていません。${i?.error}`)
};

export const sandboxes_line_preparing = /** @type {(inputs: Sandboxes_Line_PreparingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を用意しています。送った発言は用意ができたら届きます`)
};

export const sandboxes_line_queued = /** @type {(inputs: Sandboxes_Line_QueuedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} は順番待ち(${i?.n} 番目)です。サーバーの空きを待っていて、空くと自動で起きます。送った発言は起きたあと届きます`)
};

export const sandboxes_line_waking = /** @type {(inputs: Sandboxes_Line_WakingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を起こしています。送った発言は起きたら届きます`)
};

export const sandboxes_menu_previews = /** @type {(inputs: Sandboxes_Menu_PreviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビュー`)
};

export const sandboxes_name_dev = /** @type {(inputs: Sandboxes_Name_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用の trameria cloud`)
};

export const sandboxes_name_general = /** @type {(inputs: Sandboxes_Name_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const sandboxes_preview_forbidden = /** @type {(inputs: Sandboxes_Preview_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプレビューを見る権限がありません。`)
};

export const sandboxes_preview_open_failed = /** @type {(inputs: Sandboxes_Preview_Open_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューを開けませんでした。少し待ってからもう一度開いてください。`)
};

export const sandboxes_preview_opening = /** @type {(inputs: Sandboxes_Preview_OpeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューを開いています…`)
};

export const sandboxes_previews_description = /** @type {(inputs: Sandboxes_Previews_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用の trameria cloud で動いているプレビューです。休止中の sandbox は、持ち主が話しかけるか、前に開いたプレビューの URL を開くと起きます。`)
};

export const sandboxes_previews_empty = /** @type {(inputs: Sandboxes_Previews_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発用の trameria cloud はまだありません`)
};

export const sandboxes_previews_last_seen = /** @type {(inputs: Sandboxes_Previews_Last_SeenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最後に見られた ${i?.time}`)
};

export const sandboxes_previews_none_running = /** @type {(inputs: Sandboxes_Previews_None_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動いているプレビューはありません`)
};

export const sandboxes_previews_status_conflict = /** @type {(inputs: Sandboxes_Previews_Status_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じ名前になる worktree が 2 つあります`)
};

export const sandboxes_previews_status_failed = /** @type {(inputs: Sandboxes_Previews_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立てられませんでした`)
};

export const sandboxes_previews_status_missing = /** @type {(inputs: Sandboxes_Previews_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`worktree がありません`)
};

export const sandboxes_previews_status_running = /** @type {(inputs: Sandboxes_Previews_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動いています`)
};

export const sandboxes_previews_stop = /** @type {(inputs: Sandboxes_Previews_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止める`)
};

export const sandboxes_previews_stop_failed = /** @type {(inputs: Sandboxes_Previews_Stop_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を止められませんでした`)
};

export const sandboxes_previews_stop_label = /** @type {(inputs: Sandboxes_Previews_Stop_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を止める`)
};

export const sandboxes_previews_stop_offline = /** @type {(inputs: Sandboxes_Previews_Stop_OfflineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を止められませんでした。sandbox が動いていないので、止めるものがありません`)
};

export const sandboxes_previews_stopping = /** @type {(inputs: Sandboxes_Previews_StoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`止めています…`)
};

export const sandboxes_previews_title = /** @type {(inputs: Sandboxes_Previews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビュー`)
};

export const sandboxes_status_asleep = /** @type {(inputs: Sandboxes_Status_AsleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`休止中`)
};

export const sandboxes_status_deleting = /** @type {(inputs: Sandboxes_Status_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消しています`)
};

export const sandboxes_status_error = /** @type {(inputs: Sandboxes_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`うまく動いていません`)
};

export const sandboxes_status_preparing = /** @type {(inputs: Sandboxes_Status_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用意しています`)
};

export const sandboxes_status_queued = /** @type {(inputs: Sandboxes_Status_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち`)
};

export const sandboxes_status_queued_at = /** @type {(inputs: Sandboxes_Status_Queued_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`順番待ち · ${i?.n} 番目`)
};

export const sandboxes_status_running = /** @type {(inputs: Sandboxes_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起動中`)
};

export const sandboxes_status_waking = /** @type {(inputs: Sandboxes_Status_WakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起こしています`)
};

export const vc_calls = /** @type {(inputs: Vc_CallsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話`)
};

export const vc_cancel = /** @type {(inputs: Vc_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

export const vc_close_disabled = /** @type {(inputs: Vc_Close_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space では通話が切られています`)
};

export const vc_close_ended = /** @type {(inputs: Vc_Close_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了した通話`)
};

export const vc_close_full = /** @type {(inputs: Vc_Close_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`満員(4 人まで)`)
};

export const vc_close_not_found = /** @type {(inputs: Vc_Close_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見つからない通話`)
};

export const vc_close_replaced = /** @type {(inputs: Vc_Close_ReplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のタブで参加中`)
};

export const vc_closed_rejoin = /** @type {(inputs: Vc_Closed_RejoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切れました。参加し直す`)
};

export const vc_conn_closed = /** @type {(inputs: Vc_Conn_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切断`)
};

export const vc_conn_connected = /** @type {(inputs: Vc_Conn_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続済み`)
};

export const vc_conn_connecting = /** @type {(inputs: Vc_Conn_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続中`)
};

export const vc_conn_failed = /** @type {(inputs: Vc_Conn_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続できません`)
};

export const vc_conn_unstable = /** @type {(inputs: Vc_Conn_UnstableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切れかけ`)
};

export const vc_denoise_loading = /** @type {(inputs: Vc_Denoise_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノイズ抑制: 準備中`)
};

export const vc_denoise_off = /** @type {(inputs: Vc_Denoise_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノイズ抑制: オフ`)
};

export const vc_denoise_on = /** @type {(inputs: Vc_Denoise_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノイズ抑制: オン`)
};

export const vc_denoise_unavailable = /** @type {(inputs: Vc_Denoise_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノイズ抑制を用意できなかったので、素のマイクの音を送っています。`)
};

export const vc_elapsed = /** @type {(inputs: Vc_ElapsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.elapsed} 経過`)
};

export const vc_empty = /** @type {(inputs: Vc_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ通話がありません`)
};

export const vc_end = /** @type {(inputs: Vc_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を終える`)
};

export const vc_end_failed = /** @type {(inputs: Vc_End_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を終えられませんでした`)
};

export const vc_ended_mark = /** @type {(inputs: Vc_Ended_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了`)
};

export const vc_ended_sub = /** @type {(inputs: Vc_Ended_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.when} · ${i?.duration} · ${i?.people}`)
};

export const vc_filter = /** @type {(inputs: Vc_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話の絞り込み`)
};

export const vc_filter_all = /** @type {(inputs: Vc_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

export const vc_filter_ended = /** @type {(inputs: Vc_Filter_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`履歴`)
};

export const vc_filter_live = /** @type {(inputs: Vc_Filter_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話中`)
};

export const vc_join = /** @type {(inputs: Vc_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加する`)
};

export const vc_join_prepare_failed = /** @type {(inputs: Vc_Join_Prepare_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続の準備に失敗した。もう一度押す`)
};

export const vc_joined_aria = /** @type {(inputs: Vc_Joined_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`参加中の通話: ${i?.title}`)
};

export const vc_leave = /** @type {(inputs: Vc_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退出`)
};

export const vc_live_mark = /** @type {(inputs: Vc_Live_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話中`)
};

export const vc_load_failed = /** @type {(inputs: Vc_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を読み込めませんでした`)
};

export const vc_mic_denied = /** @type {(inputs: Vc_Mic_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マイクの許可が要る。ブラウザの設定で許可してからもう一度。`)
};

export const vc_minutes = /** @type {(inputs: Vc_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}分`)
};

export const vc_mute = /** @type {(inputs: Vc_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミュート`)
};

export const vc_muted = /** @type {(inputs: Vc_MutedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミュート`)
};

export const vc_narrow = /** @type {(inputs: Vc_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を絞り込む`)
};

export const vc_narrow_title = /** @type {(inputs: Vc_Narrow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名で絞り込む`)
};

export const vc_new_call = /** @type {(inputs: Vc_New_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい通話`)
};

export const vc_new_note = /** @type {(inputs: Vc_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い捨ての通話。4 人まで。音声は残らない。`)
};

export const vc_no_space = /** @type {(inputs: Vc_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を始められる Space がありません`)
};

export const vc_nobody = /** @type {(inputs: Vc_NobodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ誰もいない`)
};

export const vc_none_match = /** @type {(inputs: Vc_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる通話はありません`)
};

export const vc_not_found = /** @type {(inputs: Vc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この通話は見つかりません`)
};

export const vc_note_ended = /** @type {(inputs: Vc_Note_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了した通話。音声は残していない。`)
};

export const vc_note_live = /** @type {(inputs: Vc_Note_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い捨ての通話。閉じると消える。残したいことがあれば会話に書き出す。`)
};

export const vc_own_screen = /** @type {(inputs: Vc_Own_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の画面(相手にはこう見えています)`)
};

export const vc_people = /** @type {(inputs: Vc_PeopleInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("ja", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count}人`)
};

export const vc_play_audio = /** @type {(inputs: Vc_Play_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声を再生`)
};

export const vc_reconnecting = /** @type {(inputs: Vc_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繋ぎ直しています`)
};

export const vc_screen_of = /** @type {(inputs: Vc_Screen_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の画面`)
};

export const vc_self_suffix = /** @type {(inputs: Vc_Self_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(自分)`)
};

export const vc_share_screen = /** @type {(inputs: Vc_Share_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面を共有`)
};

export const vc_sharing = /** @type {(inputs: Vc_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画面共有中`)
};

export const vc_space_label = /** @type {(inputs: Vc_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const vc_start = /** @type {(inputs: Vc_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を始める`)
};

export const vc_start_failed = /** @type {(inputs: Vc_Start_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話を始められませんでした`)
};

export const vc_stop_sharing = /** @type {(inputs: Vc_Stop_SharingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有を止める`)
};

export const vc_title_aria = /** @type {(inputs: Vc_Title_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話の題名`)
};

export const vc_title_label = /** @type {(inputs: Vc_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const vc_title_placeholder = /** @type {(inputs: Vc_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何を話すか`)
};

export const vc_to_list = /** @type {(inputs: Vc_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧へ`)
};

export const vc_unknown_member = /** @type {(inputs: Vc_Unknown_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抜けたメンバー`)
};

export const vc_unmute = /** @type {(inputs: Vc_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミュート解除`)
};

export const vc_waiting_video = /** @type {(inputs: Vc_Waiting_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`映像を待っています`)
};

export const wd_col_space = /** @type {(inputs: Wd_Col_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const wd_datasets = /** @type {(inputs: Wd_DatasetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset`)
};

export const wd_datasets_back = /** @type {(inputs: Wd_Datasets_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents に戻る`)
};

export const wd_datasets_create = /** @type {(inputs: Wd_Datasets_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成`)
};

export const wd_datasets_create_failed = /** @type {(inputs: Wd_Datasets_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を作成できませんでした`)
};

export const wd_datasets_empty = /** @type {(inputs: Wd_Datasets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ Dataset はありません。`)
};

export const wd_datasets_load_failed = /** @type {(inputs: Wd_Datasets_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset を読み込めませんでした`)
};

export const wd_datasets_new = /** @type {(inputs: Wd_Datasets_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Dataset`)
};

export const wd_datasets_new_note = /** @type {(inputs: Wd_Datasets_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプトや Agent が送る JSON の行を貯めます。項目は届いた行から推定されます。項目や保持期間を決めておくときは Agent に頼んでください。`)
};

export const wd_datasets_none_match = /** @type {(inputs: Wd_Datasets_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる Dataset はありません。`)
};

export const wd_datasets_rows = /** @type {(inputs: Wd_Datasets_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 行`)
};

export const wd_datasets_space = /** @type {(inputs: Wd_Datasets_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const wd_datasets_space_empty = /** @type {(inputs: Wd_Datasets_Space_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ Dataset はありません。`)
};

export const wd_datasets_title = /** @type {(inputs: Wd_Datasets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`題名`)
};

export const wd_empty = /** @type {(inputs: Wd_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ文書はありません。`)
};

export const wd_load_failed = /** @type {(inputs: Wd_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を読み込めませんでした`)
};

export const wd_move_failed = /** @type {(inputs: Wd_Move_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を移せませんでした`)
};

export const wd_move_hint = /** @type {(inputs: Wd_Move_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移した先の Space が見える人だけが見られるようになります。`)
};

export const wd_move_title = /** @type {(inputs: Wd_Move_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を別の Space へ移す`)
};

export const wd_nav = /** @type {(inputs: Wd_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

export const wd_new_in = /** @type {(inputs: Wd_New_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作る Space`)
};

export const wd_no_space = /** @type {(inputs: Wd_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を置ける Space がありません。`)
};

export const wd_none_match = /** @type {(inputs: Wd_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる文書はありません。`)
};

export const wd_pin_failed = /** @type {(inputs: Wd_Pin_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」の留め方を変えられませんでした`)
};

export const wd_release = /** @type {(inputs: Wd_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace に移す`)
};

export const wd_release_action = /** @type {(inputs: Wd_Release_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移す`)
};

export const wd_release_body = /** @type {(inputs: Wd_Release_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移すと、選んだ Space が見える人が読めて、Workspace で文書を書ける人が書けるようになります。自分の Index からは外れ、リンクでの公開は止まります。元には戻せません(個人の文書に残したいならコピーを作ってから)。`)
};

export const wd_release_failed = /** @type {(inputs: Wd_Release_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を移せませんでした`)
};

export const wd_release_no_space = /** @type {(inputs: Wd_Release_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace には、文書を書ける Space がありません。`)
};

export const wd_release_none = /** @type {(inputs: Wd_Release_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移せる Workspace がありません。`)
};

export const wd_release_space = /** @type {(inputs: Wd_Release_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const wd_release_title = /** @type {(inputs: Wd_Release_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を Workspace に移す`)
};

export const wd_release_workspace = /** @type {(inputs: Wd_Release_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const wd_released = /** @type {(inputs: Wd_ReleasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.title}」を ${i?.workspace} に移しました`)
};

export const wd_space_empty = /** @type {(inputs: Wd_Space_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ文書はありません。`)
};

export const web_admin_description = /** @type {(inputs: Web_Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria を運営する人だけの画面です。`)
};

export const web_admin_title = /** @type {(inputs: Web_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運営`)
};

export const web_admin_waitlist_approve = /** @type {(inputs: Web_Admin_Waitlist_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認`)
};

export const web_admin_waitlist_approve_failed = /** @type {(inputs: Web_Admin_Waitlist_Approve_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認できませんでした`)
};

export const web_admin_waitlist_approved_done = /** @type {(inputs: Web_Admin_Waitlist_Approved_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人を承認し、メールを送りました`)
};

export const web_admin_waitlist_clear = /** @type {(inputs: Web_Admin_Waitlist_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択を解除`)
};

export const web_admin_waitlist_col_email = /** @type {(inputs: Web_Admin_Waitlist_Col_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

export const web_admin_waitlist_col_joined = /** @type {(inputs: Web_Admin_Waitlist_Col_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録日`)
};

export const web_admin_waitlist_col_via = /** @type {(inputs: Web_Admin_Waitlist_Col_ViaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`経路`)
};

export const web_admin_waitlist_confirm_approve = /** @type {(inputs: Web_Admin_Waitlist_Confirm_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認する`)
};

export const web_admin_waitlist_confirm_text = /** @type {(inputs: Web_Admin_Waitlist_Confirm_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人にサインインの案内をメールで送ります`)
};

export const web_admin_waitlist_description = /** @type {(inputs: Web_Admin_Waitlist_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認すると、その人にサインインできるようになった旨をメールで知らせます。`)
};

export const web_admin_waitlist_empty = /** @type {(inputs: Web_Admin_Waitlist_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ちの人はいません`)
};

export const web_admin_waitlist_select_all = /** @type {(inputs: Web_Admin_Waitlist_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて選択`)
};

export const web_admin_waitlist_selected = /** @type {(inputs: Web_Admin_Waitlist_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人を選択`)
};

export const web_admin_waitlist_title = /** @type {(inputs: Web_Admin_Waitlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち`)
};

export const web_admin_waitlist_toolbar = /** @type {(inputs: Web_Admin_Waitlist_ToolbarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択中の操作`)
};

export const web_admin_waitlist_via_email = /** @type {(inputs: Web_Admin_Waitlist_Via_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール`)
};

export const web_app_update_load = /** @type {(inputs: Web_App_Update_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいバージョンを読み込む`)
};

export const web_banned = /** @type {(inputs: Web_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアカウントは利用を停止されています。心当たりがなければ運営者に連絡してください`)
};

export const web_captcha_failed = /** @type {(inputs: Web_Captcha_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認に失敗しました。もう一度お試しください`)
};

export const web_home_icon = /** @type {(inputs: Web_Home_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム画面のアイコン`)
};

export const web_home_icon_black = /** @type {(inputs: Web_Home_Icon_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黒`)
};

export const web_home_icon_green = /** @type {(inputs: Web_Home_Icon_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`緑`)
};

export const web_home_icon_ground_black = /** @type {(inputs: Web_Home_Icon_Ground_BlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黒地`)
};

export const web_home_icon_ground_white = /** @type {(inputs: Web_Home_Icon_Ground_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白地`)
};

export const web_home_icon_ink = /** @type {(inputs: Web_Home_Icon_InkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`墨`)
};

export const web_home_icon_note = /** @type {(inputs: Web_Home_Icon_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「ホーム画面に追加」するときの色と地。このブラウザに保存されます。追加済みのアイコンは変わらないので、替えたら追加し直してください。`)
};

export const web_home_icon_purple = /** @type {(inputs: Web_Home_Icon_PurpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`紫`)
};

export const web_home_icon_standard = /** @type {(inputs: Web_Home_Icon_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準`)
};

export const web_home_icon_vermilion = /** @type {(inputs: Web_Home_Icon_VermilionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`朱`)
};

export const web_home_icon_white = /** @type {(inputs: Web_Home_Icon_WhiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`白`)
};

export const web_hub_allow = /** @type {(inputs: Web_Hub_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携`)
};

export const web_hub_code_label = /** @type {(inputs: Web_Hub_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault やデバイスに出たコード`)
};

export const web_hub_code_next = /** @type {(inputs: Web_Hub_Code_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次へ`)
};

export const web_hub_connecting = /** @type {(inputs: Web_Hub_ConnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault(${i?.name})が、このアカウントとの連携を求めています。`)
};

export const web_hub_denied = /** @type {(inputs: Web_Hub_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否しました。この Vault は連携していません。`)
};

export const web_hub_deny = /** @type {(inputs: Web_Hub_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否`)
};

export const web_hub_desktop_connecting = /** @type {(inputs: Web_Hub_Desktop_ConnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」のデバイスが、このアカウントとの連携を求めています。`)
};

export const web_hub_desktop_denied = /** @type {(inputs: Web_Hub_Desktop_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否しました。このデバイスは連携していません。`)
};

export const web_hub_desktop_done = /** @type {(inputs: Web_Hub_Desktop_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携しました。デバイスに戻ってください。`)
};

export const web_hub_desktop_what = /** @type {(inputs: Web_Hub_Desktop_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携すると、このデバイスが自分でこのアカウントの Cloud を使えるようになります。デバイスでサインアウトするまで続きます。`)
};

export const web_hub_done = /** @type {(inputs: Web_Hub_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携しました。Vault に戻ってください。`)
};

export const web_hub_failed = /** @type {(inputs: Web_Hub_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携できませんでした`)
};

export const web_hub_not_found = /** @type {(inputs: Web_Hub_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードが見つからないか、期限が切れています。Vault やデバイスでもう一度始めてください。`)
};

export const web_hub_pair_pc = /** @type {(inputs: Web_Hub_Pair_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC では、Vault の画面に出ているコードを、Trameria の「Vault に接続する」に入れてください。`)
};

export const web_hub_pair_phone = /** @type {(inputs: Web_Hub_Pair_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone・iPad では Trameria アプリで開きます。アプリが開かなかったときは、アプリを入れてから、もう一度 QR を読んでください。`)
};

export const web_hub_pair_title = /** @type {(inputs: Web_Hub_Pair_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault とつなぐ`)
};

export const web_hub_started_at = /** @type {(inputs: Web_Hub_Started_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`始めた日時: ${i?.time}`)
};

export const web_hub_started_from = /** @type {(inputs: Web_Hub_Started_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`始めた場所: ${i?.place}`)
};

export const web_hub_title = /** @type {(inputs: Web_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントと連携`)
};

export const web_hub_type_code = /** @type {(inputs: Web_Hub_Type_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリンクは、いま使っているネットワークとは別の場所で始まった連携です。自分で始めた連携なら、Vault やデバイスの画面に出ているコードを入れてください。`)
};

export const web_hub_warning = /** @type {(inputs: Web_Hub_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分で始めたのでなければ連携しないでください`)
};

export const web_hub_what = /** @type {(inputs: Web_Hub_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携すると、この Vault の持ち主はこのアカウントになります。Vault で連携を解除するまで、ほかのアカウントとは連携できません。`)
};

export const web_load_failed = /** @type {(inputs: Web_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const web_mail_failed = /** @type {(inputs: Web_Mail_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールを送れませんでした。しばらくして試してください`)
};

export const web_me_moving_body = /** @type {(inputs: Web_Me_Moving_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを Cloud と Vault の間で移しているところです。終わるまで、ここでは Personal データを開けません。Workspace はそのまま使えます。`)
};

export const web_me_moving_open_here = /** @type {(inputs: Web_Me_Moving_Open_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC の画面で見る`)
};

export const web_me_moving_title = /** @type {(inputs: Web_Me_Moving_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データを移しています`)
};

export const web_me_on_hub_body = /** @type {(inputs: Web_Me_On_Hub_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personal データは Vault(${i?.hub})にあります。Vault に繋いだ desktop で開いてください。Workspace はここでそのまま使えます。`)
};

export const web_me_on_hub_body_unnamed = /** @type {(inputs: Web_Me_On_Hub_Body_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Vault にあります。Vault に繋いだ desktop で開いてください。Workspace はここでそのまま使えます。`)
};

export const web_me_on_hub_title = /** @type {(inputs: Web_Me_On_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Vault にあります`)
};

export const web_me_opening_here = /** @type {(inputs: Web_Me_Opening_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal データは Vault にあります。この PC の画面を開いています…`)
};

export const web_menu_admin = /** @type {(inputs: Web_Menu_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運営`)
};

export const web_menu_sign_out = /** @type {(inputs: Web_Menu_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインアウト`)
};

export const web_oauth_allow = /** @type {(inputs: Web_Oauth_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可する`)
};

export const web_oauth_can_do = /** @type {(inputs: Web_Oauth_Can_DoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`できること`)
};

export const web_oauth_connecting = /** @type {(inputs: Web_Oauth_ConnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.client} が trameria に接続しようとしています。`)
};

export const web_oauth_deny = /** @type {(inputs: Web_Oauth_DenyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拒否する`)
};

export const web_oauth_desktop_warning = /** @type {(inputs: Web_Oauth_Desktop_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分で開いたアプリでなければ許可しないでください`)
};

export const web_oauth_destination = /** @type {(inputs: Web_Oauth_DestinationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`接続先: ${i?.where}`)
};

export const web_oauth_failed = /** @type {(inputs: Web_Oauth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続を許可できませんでした`)
};

export const web_oauth_outside_flow = /** @type {(inputs: Web_Oauth_Outside_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この画面は、MCP クライアント(claude.ai や Claude Code)から trameria への接続を始めると開きます。`)
};

export const web_oauth_scope_desktop = /** @type {(inputs: Web_Oauth_Scope_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この PC やスマートフォンのアプリに、あなたとして trameria にサインインさせる`)
};

export const web_oauth_scope_offline = /** @type {(inputs: Web_Oauth_Scope_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続の維持(サインアウトしても、設定の「接続済みアプリ」で解除するまで繋がったまま)`)
};

export const web_oauth_scope_read = /** @type {(inputs: Web_Oauth_Scope_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り(Case・People・文書を読む)`)
};

export const web_oauth_scope_write = /** @type {(inputs: Web_Oauth_Scope_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き込み(Case・People・文書の作成と更新)`)
};

export const web_oauth_this_device = /** @type {(inputs: Web_Oauth_This_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このデバイスのアプリ(${i?.where})`)
};

export const web_oauth_title = /** @type {(inputs: Web_Oauth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続の許可`)
};

export const web_oauth_unverified = /** @type {(inputs: Web_Oauth_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確かめていないアプリです。名前はアプリが自分で名乗ったもので、trameria は確かめていません。接続先に心当たりがなければ拒否してください。`)
};

export const web_otp_expired = /** @type {(inputs: Web_Otp_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードの期限が切れました。もう一度送ってください`)
};

export const web_otp_invalid = /** @type {(inputs: Web_Otp_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードが違います`)
};

export const web_otp_too_many = /** @type {(inputs: Web_Otp_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回数の上限に達しました。もう一度コードを送ってください`)
};

export const web_passkey_failed = /** @type {(inputs: Web_Passkey_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーでサインインできませんでした`)
};

export const web_passkey_later = /** @type {(inputs: Web_Passkey_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あとで`)
};

export const web_passkey_later_note = /** @type {(inputs: Web_Passkey_Later_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あとから 設定 → サインイン・セキュリティ でも登録できます。`)
};

export const web_passkey_lead = /** @type {(inputs: Web_Passkey_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次からは指紋・顔・PIN だけでサインインできます。`)
};

export const web_passkey_none = /** @type {(inputs: Web_Passkey_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスにはまだパスキーがありません。メールアドレスで続けてください`)
};

export const web_passkey_register = /** @type {(inputs: Web_Passkey_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録する`)
};

export const web_passkey_register_failed = /** @type {(inputs: Web_Passkey_Register_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを登録できませんでした`)
};

export const web_passkey_title = /** @type {(inputs: Web_Passkey_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを登録`)
};

export const web_rate_limited = /** @type {(inputs: Web_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`しばらく待ってからもう一度お試しください`)
};

export const web_resend_too_soon = /** @type {(inputs: Web_Resend_Too_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信の間隔が短すぎます`)
};

export const web_retry = /** @type {(inputs: Web_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度`)
};

export const web_settings_apps = /** @type {(inputs: Web_Settings_AppsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続済みアプリ`)
};

export const web_settings_apps_allow_workspace = /** @type {(inputs: Web_Settings_Apps_Allow_WorkspaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を接続したアプリに許可する`)
};

export const web_settings_apps_app_description = /** @type {(inputs: Web_Settings_Apps_App_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.scopes} · 許可 ${i?.granted}`)
};

export const web_settings_apps_copied = /** @type {(inputs: Web_Settings_Apps_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const web_settings_apps_copy = /** @type {(inputs: Web_Settings_Apps_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

export const web_settings_apps_description = /** @type {(inputs: Web_Settings_Apps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外のアプリ(Claude など)から trameria を使う接続です。`)
};

export const web_settings_apps_disconnect = /** @type {(inputs: Web_Settings_Apps_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続を解除`)
};

export const web_settings_apps_disconnect_body = /** @type {(inputs: Web_Settings_Apps_Disconnect_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリからの次の呼び出しは断られます。もう一度使うには、アプリ側から接続をやり直します。`)
};

export const web_settings_apps_disconnect_failed = /** @type {(inputs: Web_Settings_Apps_Disconnect_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の接続を解除できませんでした`)
};

export const web_settings_apps_disconnect_title = /** @type {(inputs: Web_Settings_Apps_Disconnect_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の接続を解除します`)
};

export const web_settings_apps_empty = /** @type {(inputs: Web_Settings_Apps_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続しているアプリはありません。`)
};

export const web_settings_apps_list = /** @type {(inputs: Web_Settings_Apps_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリ`)
};

export const web_settings_apps_no_workspaces = /** @type {(inputs: Web_Settings_Apps_No_WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所属している Workspace はありません。`)
};

export const web_settings_apps_not_allowed = /** @type {(inputs: Web_Settings_Apps_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace の管理者が MCP を許可していません`)
};

export const web_settings_apps_scope_desktop = /** @type {(inputs: Web_Settings_Apps_Scope_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デスクトップアプリ`)
};

export const web_settings_apps_scope_offline = /** @type {(inputs: Web_Settings_Apps_Scope_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続の維持`)
};

export const web_settings_apps_scope_read = /** @type {(inputs: Web_Settings_Apps_Scope_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み取り`)
};

export const web_settings_apps_scope_write = /** @type {(inputs: Web_Settings_Apps_Scope_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`書き込み`)
};

export const web_settings_apps_url = /** @type {(inputs: Web_Settings_Apps_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続先`)
};

export const web_settings_apps_url_note = /** @type {(inputs: Web_Settings_Apps_Url_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude のコネクタ追加にこの URL を貼ります。`)
};

export const web_settings_apps_workspace_failed = /** @type {(inputs: Web_Settings_Apps_Workspace_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」の許可を変えられませんでした`)
};

export const web_settings_apps_workspaces = /** @type {(inputs: Web_Settings_Apps_WorkspacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const web_settings_apps_workspaces_note = /** @type {(inputs: Web_Settings_Apps_Workspaces_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`許可した Workspace だけを、接続したアプリから読み書きできます。`)
};

export const web_settings_description = /** @type {(inputs: Web_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての Workspace で共通の、自分の設定。`)
};

export const web_settings_security = /** @type {(inputs: Web_Settings_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン・セキュリティ`)
};

export const web_settings_security_add = /** @type {(inputs: Web_Settings_Security_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを追加`)
};

export const web_settings_security_add_failed = /** @type {(inputs: Web_Settings_Security_Add_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーを登録できませんでした`)
};

export const web_settings_security_delete_body = /** @type {(inputs: Web_Settings_Security_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスからはこのパスキーで入れなくなります。`)
};

export const web_settings_security_delete_failed = /** @type {(inputs: Web_Settings_Security_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」を削除できませんでした`)
};

export const web_settings_security_delete_last_body = /** @type {(inputs: Web_Settings_Security_Delete_Last_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これが最後のパスキーです。消すと、次からはメールのコードで入ります。`)
};

export const web_settings_security_delete_named = /** @type {(inputs: Web_Settings_Security_Delete_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を削除`)
};

export const web_settings_security_delete_title = /** @type {(inputs: Web_Settings_Security_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`パスキー「${i?.name}」を削除します`)
};

export const web_settings_security_description = /** @type {(inputs: Web_Settings_Security_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインの手段。パスキーがあればコードの入力なしで入れます。`)
};

export const web_settings_security_email = /** @type {(inputs: Web_Settings_Security_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

export const web_settings_security_email_note = /** @type {(inputs: Web_Settings_Security_Email_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインコードの送り先。`)
};

export const web_settings_security_google = /** @type {(inputs: Web_Settings_Security_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google`)
};

export const web_settings_security_google_link = /** @type {(inputs: Web_Settings_Security_Google_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携する`)
};

export const web_settings_security_google_link_failed = /** @type {(inputs: Web_Settings_Security_Google_Link_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google と連携できませんでした`)
};

export const web_settings_security_google_linked = /** @type {(inputs: Web_Settings_Security_Google_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連携済み`)
};

export const web_settings_security_google_not_configured = /** @type {(inputs: Web_Settings_Security_Google_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境では使えません`)
};

export const web_settings_security_google_note = /** @type {(inputs: Web_Settings_Security_Google_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google アカウントでもサインインできるようにする。`)
};

export const web_settings_security_passkeys = /** @type {(inputs: Web_Settings_Security_PasskeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキー`)
};

export const web_settings_security_passkeys_note = /** @type {(inputs: Web_Settings_Security_Passkeys_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このデバイスやパスワードマネージャに登録したパスキー。`)
};

export const web_settings_security_registered_on = /** @type {(inputs: Web_Settings_Security_Registered_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`登録日 ${i?.date}`)
};

export const web_settings_security_unnamed = /** @type {(inputs: Web_Settings_Security_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前なし`)
};

export const web_settings_title = /** @type {(inputs: Web_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント設定`)
};

export const web_signin_code_label = /** @type {(inputs: Web_Signin_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コード`)
};

export const web_signin_code_reused = /** @type {(inputs: Web_Signin_Code_ReusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} に先ほど送ったコードが使えます。コードは ${i?.minutes} 分有効です。`)
};

export const web_signin_code_sent = /** @type {(inputs: Web_Signin_Code_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} に 6 桁のコードを送りました。コードは ${i?.minutes} 分有効です。`)
};

export const web_signin_continue = /** @type {(inputs: Web_Signin_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

export const web_signin_email_hint = /** @type {(inputs: Web_Signin_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 桁のコードをメールで送ります`)
};

export const web_signin_email_invalid = /** @type {(inputs: Web_Signin_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスの形が正しくありません`)
};

export const web_signin_email_label = /** @type {(inputs: Web_Signin_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

export const web_signin_failed = /** @type {(inputs: Web_Signin_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインできませんでした`)
};

export const web_signin_google = /** @type {(inputs: Web_Signin_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google で続ける`)
};

export const web_signin_google_failed = /** @type {(inputs: Web_Signin_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google でサインインを始められませんでした`)
};

export const web_signin_in_app_body = /** @type {(inputs: Web_Signin_In_App_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリの設定の「Cloud」でサインインし直してください。サインインはブラウザで行います。`)
};

export const web_signin_in_app_title = /** @type {(inputs: Web_Signin_In_App_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud からサインアウトしています`)
};

export const web_signin_other_email = /** @type {(inputs: Web_Signin_Other_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のメールアドレス`)
};

export const web_signin_passkey = /** @type {(inputs: Web_Signin_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスキーでサインイン`)
};

export const web_signin_resend = /** @type {(inputs: Web_Signin_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを再送`)
};

export const web_signin_resent = /** @type {(inputs: Web_Signin_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送り直しました`)
};

export const web_signin_retry = /** @type {(inputs: Web_Signin_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインできませんでした。少し待ってからやり直してください`)
};

export const web_signin_title = /** @type {(inputs: Web_Signin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン`)
};

export const web_trust_approve_pc = /** @type {(inputs: Web_Trust_Approve_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC では、QR コードの下に表示されているコードを、Trameria のアプリの設定の「デバイスリスト」の「デバイスを追加」で入力してください。`)
};

export const web_trust_approve_phone = /** @type {(inputs: Web_Trust_Approve_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone・iPad では Trameria アプリで開きます。アプリが開かなかったときは、アプリをインストールしてから、もう一度 QR コードを読み取ってください。`)
};

export const web_trust_approve_title = /** @type {(inputs: Web_Trust_Approve_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デバイスリストに追加する`)
};

export const web_waitlist_body = /** @type {(inputs: Web_Waitlist_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`順番待ちに入りました。承認されたら ${i?.email} にメールで知らせます。メールが届いたら、この画面に戻ると先へ進みます。`)
};

export const web_waitlist_switch = /** @type {(inputs: Web_Waitlist_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別のアカウントでサインイン`)
};

export const web_waitlist_title = /** @type {(inputs: Web_Waitlist_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順番待ち`)
};

export const workspace_default_role_admin = /** @type {(inputs: Workspace_Default_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者`)
};

export const workspace_default_space_name = /** @type {(inputs: Workspace_Default_Space_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般`)
};

export const workspace_unnamed_member = /** @type {(inputs: Workspace_Unnamed_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前なし`)
};

export const ws_cancel = /** @type {(inputs: Ws_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やめる`)
};

export const ws_case_panel = /** @type {(inputs: Ws_Case_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const ws_delete = /** @type {(inputs: Ws_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const ws_dock_spaces = /** @type {(inputs: Ws_Dock_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const ws_feature_broadcast = /** @type {(inputs: Ws_Feature_BroadcastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcast`)
};

export const ws_feature_broadcast_note = /** @type {(inputs: Ws_Feature_Broadcast_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全員に届くお知らせ`)
};

export const ws_feature_cycle = /** @type {(inputs: Ws_Feature_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle`)
};

export const ws_feature_cycle_note = /** @type {(inputs: Ws_Feature_Cycle_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue を区切る期間`)
};

export const ws_feature_dm = /** @type {(inputs: Ws_Feature_DmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const ws_feature_dm_note = /** @type {(inputs: Ws_Feature_Dm_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 対 1 のやりとり`)
};

export const ws_feature_document = /** @type {(inputs: Ws_Feature_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書`)
};

export const ws_feature_document_note = /** @type {(inputs: Ws_Feature_Document_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共同編集する文書`)
};

export const ws_feature_issue = /** @type {(inputs: Ws_Feature_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue`)
};

export const ws_feature_issue_note = /** @type {(inputs: Ws_Feature_Issue_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個々の作業`)
};

export const ws_feature_journal = /** @type {(inputs: Ws_Feature_JournalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

export const ws_feature_journal_note = /** @type {(inputs: Ws_Feature_Journal_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人ごとのタイムライン`)
};

export const ws_feature_project = /** @type {(inputs: Ws_Feature_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

export const ws_feature_project_note = /** @type {(inputs: Ws_Feature_Project_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まとまった仕事の単位`)
};

export const ws_feature_requires = /** @type {(inputs: Ws_Feature_RequiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.feature} が要ります`)
};

export const ws_feature_topic = /** @type {(inputs: Ws_Feature_TopicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話`)
};

export const ws_feature_topic_note = /** @type {(inputs: Ws_Feature_Topic_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space の会話`)
};

export const ws_feature_voice = /** @type {(inputs: Ws_Feature_VoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通話`)
};

export const ws_feature_voice_note = /** @type {(inputs: Ws_Feature_Voice_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その場の通話`)
};

export const ws_features_enabled = /** @type {(inputs: Ws_Features_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使う機能`)
};

export const ws_features_mcp = /** @type {(inputs: Ws_Features_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外のアプリからの MCP を許す`)
};

export const ws_features_mcp_note = /** @type {(inputs: Ws_Features_Mcp_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切ると、メンバーは外のアプリからこの Workspace を読み書きできません。デバイスの Agent は変わりません`)
};

export const ws_features_outside = /** @type {(inputs: Ws_Features_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外からの使い方`)
};

export const ws_features_publish = /** @type {(inputs: Ws_Features_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクでの公開を許す`)
};

export const ws_features_publish_note = /** @type {(inputs: Ws_Features_Publish_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開した文書は、リンクを知っている人なら誰でも読めます`)
};

export const ws_features_publish_off = /** @type {(inputs: Ws_Features_Publish_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切る`)
};

export const ws_features_publish_off_body = /** @type {(inputs: Ws_Features_Publish_Off_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開中の文書はすべて止まり、そのリンクは開けなくなります。入れ直しても戻りません。`)
};

export const ws_features_publish_off_title = /** @type {(inputs: Ws_Features_Publish_Off_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のリンクでの公開を切りますか`)
};

export const ws_general_icon = /** @type {(inputs: Ws_General_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコン`)
};

export const ws_general_icon_note = /** @type {(inputs: Ws_General_Icon_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レールやメニューでこの Workspace を表す画像。無ければ名前の頭文字が出ます`)
};

export const ws_general_name = /** @type {(inputs: Ws_General_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const ws_general_url = /** @type {(inputs: Ws_General_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

export const ws_general_url_change = /** @type {(inputs: Ws_General_Url_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変える`)
};

export const ws_general_url_edit = /** @type {(inputs: Ws_General_Url_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更`)
};

export const ws_general_url_edit_title = /** @type {(inputs: Ws_General_Url_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL を変える`)
};

export const ws_general_url_note = /** @type {(inputs: Ws_General_Url_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変えると、前の URL のリンクは開けなくなります`)
};

export const ws_home_empty = /** @type {(inputs: Ws_Home_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話・文書・Issue・通話は、それぞれの機能が揃いしだいサイドバーに並びます。自分の Case は「Cases」から開けます。`)
};

export const ws_invite_failed = /** @type {(inputs: Ws_Invite_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加できませんでした`)
};

export const ws_invite_guest_note = /** @type {(inputs: Ws_Invite_Guest_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.kind} として参加します。見られるのは、全員に見える Space と参加した Space だけです。`)
};

export const ws_invite_join = /** @type {(inputs: Ws_Invite_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加する`)
};

export const ws_invite_loading = /** @type {(inputs: Ws_Invite_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込んでいます`)
};

export const ws_invite_not_found = /** @type {(inputs: Ws_Invite_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この招待のリンクは見つかりませんでした。`)
};

export const ws_invite_sign_in = /** @type {(inputs: Ws_Invite_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインして参加`)
};

export const ws_invite_title = /** @type {(inputs: Ws_Invite_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待`)
};

export const ws_invite_to = /** @type {(inputs: Ws_Invite_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.workspace} に招待されています。`)
};

export const ws_invite_unusable = /** @type {(inputs: Ws_Invite_UnusableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.workspace} への招待のリンクは、期限切れか失効したか、回数を使い切っています。招待した人に新しいリンクを頼んでください。`)
};

export const ws_invites_active = /** @type {(inputs: Ws_Invites_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効`)
};

export const ws_invites_all = /** @type {(inputs: Ws_Invites_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

export const ws_invites_copied = /** @type {(inputs: Ws_Invites_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

export const ws_invites_copy = /** @type {(inputs: Ws_Invites_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー`)
};

export const ws_invites_copy_failed = /** @type {(inputs: Ws_Invites_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーできませんでした。リンクを選んで写してください`)
};

export const ws_invites_create = /** @type {(inputs: Ws_Invites_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクを作る`)
};

export const ws_invites_create_failed = /** @type {(inputs: Ws_Invites_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクを作れませんでした`)
};

export const ws_invites_days = /** @type {(inputs: Ws_Invites_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 日後まで`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 日後まで`);
	return /** @type {LocalizedString} */ ("ws_invites_days");
};

export const ws_invites_empty = /** @type {(inputs: Ws_Invites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだリンクはありません`)
};

export const ws_invites_expired = /** @type {(inputs: Ws_Invites_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限が切れました`)
};

export const ws_invites_expires = /** @type {(inputs: Ws_Invites_ExpiresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限`)
};

export const ws_invites_filter = /** @type {(inputs: Ws_Invites_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待のリンクを絞る`)
};

export const ws_invites_guest_note = /** @type {(inputs: Ws_Invites_Guest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest として参加し、全員に見える Space と参加した Space だけを見られます。ロールは付きません。`)
};

export const ws_invites_joins_as = /** @type {(inputs: Ws_Invites_Joins_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加すると`)
};

export const ws_invites_kind = /** @type {(inputs: Ws_Invites_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加するときの種別`)
};

export const ws_invites_link = /** @type {(inputs: Ws_Invites_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待のリンク`)
};

export const ws_invites_list = /** @type {(inputs: Ws_Invites_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待のリンクの一覧`)
};

export const ws_invites_max_uses = /** @type {(inputs: Ws_Invites_Max_UsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回数`)
};

export const ws_invites_member_note = /** @type {(inputs: Ws_Invites_Member_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member として参加し、@everyone と選んだロールの権限を持ちます。`)
};

export const ws_invites_never = /** @type {(inputs: Ws_Invites_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なし`)
};

export const ws_invites_new = /** @type {(inputs: Ws_Invites_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい招待のリンク`)
};

export const ws_invites_no_active = /** @type {(inputs: Ws_Invites_No_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なリンクはありません`)
};

export const ws_invites_not_found = /** @type {(inputs: Ws_Invites_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリンクは見つかりませんでした`)
};

export const ws_invites_revoke = /** @type {(inputs: Ws_Invites_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失効させる`)
};

export const ws_invites_revoke_failed = /** @type {(inputs: Ws_Invites_Revoke_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクを失効できませんでした`)
};

export const ws_invites_revoke_note = /** @type {(inputs: Ws_Invites_Revoke_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリンクでは、もう参加できなくなります`)
};

export const ws_invites_revoked = /** @type {(inputs: Ws_Invites_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失効しました`)
};

export const ws_invites_role = /** @type {(inputs: Ws_Invites_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロール`)
};

export const ws_invites_role_note = /** @type {(inputs: Ws_Invites_Role_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の一番上のロールより下のロールから選べます`)
};

export const ws_invites_times = /** @type {(inputs: Ws_Invites_TimesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 回まで`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 回まで`);
	return /** @type {LocalizedString} */ ("ws_invites_times");
};

export const ws_invites_unlimited = /** @type {(inputs: Ws_Invites_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上限なし`)
};

export const ws_invites_until = /** @type {(inputs: Ws_Invites_UntilInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} まで`)
};

export const ws_invites_url = /** @type {(inputs: Ws_Invites_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンク`)
};

export const ws_invites_url_hidden = /** @type {(inputs: Ws_Invites_Url_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたが付けられないロールで参加するリンクなので、作った人とオーナーだけが見られます`)
};

export const ws_invites_url_note = /** @type {(inputs: Ws_Invites_Url_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このリンクを渡すと参加できます`)
};

export const ws_invites_usage = /** @type {(inputs: Ws_Invites_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用 ${i?.used} / ${i?.max}`)
};

export const ws_invites_usage_unlimited = /** @type {(inputs: Ws_Invites_Usage_UnlimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用 ${i?.used} / 無制限`)
};

export const ws_invites_used_up = /** @type {(inputs: Ws_Invites_Used_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回数を使い切りました`)
};

export const ws_invites_uses = /** @type {(inputs: Ws_Invites_UsesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使った回数`)
};

export const ws_invites_uses_of = /** @type {(inputs: Ws_Invites_Uses_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.max}`)
};

export const ws_invites_uses_unlimited = /** @type {(inputs: Ws_Invites_Uses_UnlimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / 上限なし`)
};

export const ws_invites_valid = /** @type {(inputs: Ws_Invites_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使えます`)
};

export const ws_kind_guest = /** @type {(inputs: Ws_Kind_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest`)
};

export const ws_kind_member = /** @type {(inputs: Ws_Kind_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

export const ws_list_narrow = /** @type {(inputs: Ws_List_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一覧を絞り込む`)
};

export const ws_list_narrow_name = /** @type {(inputs: Ws_List_Narrow_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前で絞る`)
};

export const ws_list_no_match = /** @type {(inputs: Ws_List_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまるものはありません`)
};

export const ws_load_failed = /** @type {(inputs: Ws_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込めませんでした`)
};

export const ws_members_all = /** @type {(inputs: Ws_Members_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

export const ws_members_bulk = /** @type {(inputs: Ws_Members_BulkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選んだ人への操作`)
};

export const ws_members_bulk_clear = /** @type {(inputs: Ws_Members_Bulk_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選ぶのをやめる`)
};

export const ws_members_bulk_remove_failed = /** @type {(inputs: Ws_Members_Bulk_Remove_FailedInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("ja", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} 人を外せませんでした`)
};

export const ws_members_bulk_remove_title = /** @type {(inputs: Ws_Members_Bulk_Remove_TitleInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("ja", i?.count, {});return /** @type {LocalizedString} */ (`${i?.count} 人をこの Workspace から外しますか`)
};

export const ws_members_col_joined = /** @type {(inputs: Ws_Members_Col_JoinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace に参加`)
};

export const ws_members_col_kind = /** @type {(inputs: Ws_Members_Col_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種別`)
};

export const ws_members_col_last_active = /** @type {(inputs: Ws_Members_Col_Last_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終アクティブ`)
};

export const ws_members_col_name = /** @type {(inputs: Ws_Members_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const ws_members_col_registered = /** @type {(inputs: Ws_Members_Col_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria に登録`)
};

export const ws_members_col_roles = /** @type {(inputs: Ws_Members_Col_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロール`)
};

export const ws_members_empty = /** @type {(inputs: Ws_Members_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ誰もいません`)
};

export const ws_members_filter = /** @type {(inputs: Ws_Members_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種別とロールで絞る`)
};

export const ws_members_guest_no_roles = /** @type {(inputs: Ws_Members_Guest_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest にはロールを付けられません。`)
};

export const ws_members_joined = /** @type {(inputs: Ws_Members_JoinedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} に参加`)
};

export const ws_members_kind = /** @type {(inputs: Ws_Members_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種別`)
};

export const ws_members_kind_failed = /** @type {(inputs: Ws_Members_Kind_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の種別を変えられませんでした`)
};

export const ws_members_list = /** @type {(inputs: Ws_Members_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーの一覧`)
};

export const ws_members_make_guest = /** @type {(inputs: Ws_Members_Make_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest にする`)
};

export const ws_members_make_member = /** @type {(inputs: Ws_Members_Make_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member にする`)
};

export const ws_members_no_match = /** @type {(inputs: Ws_Members_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当てはまる人はいません`)
};

export const ws_members_no_roles = /** @type {(inputs: Ws_Members_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@everyone のほかにロールはありません。ロールの設定で作れます。`)
};

export const ws_members_not_found = /** @type {(inputs: Ws_Members_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この人はこの Workspace にいません`)
};

export const ws_members_owner = /** @type {(inputs: Ws_Members_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーナー`)
};

export const ws_members_owner_note = /** @type {(inputs: Ws_Members_Owner_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`この Workspace のオーナー。${i?.date} に作りました`)
};

export const ws_members_remove = /** @type {(inputs: Ws_Members_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

export const ws_members_remove_body = /** @type {(inputs: Ws_Members_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールと、Space の参加者・管理者からも外れます。もう一度入るには招待が要ります。`)
};

export const ws_members_remove_failed = /** @type {(inputs: Ws_Members_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外せませんでした`)
};

export const ws_members_remove_label = /** @type {(inputs: Ws_Members_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外す`)
};

export const ws_members_remove_note = /** @type {(inputs: Ws_Members_Remove_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace から外します`)
};

export const ws_members_remove_title = /** @type {(inputs: Ws_Members_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} をこの Workspace から外しますか`)
};

export const ws_members_roles = /** @type {(inputs: Ws_Members_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロール`)
};

export const ws_members_roles_above = /** @type {(inputs: Ws_Members_Roles_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付けられるのは、自分の一番上のロールより下のロールだけです。`)
};

export const ws_members_roles_failed = /** @type {(inputs: Ws_Members_Roles_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のロールを変えられませんでした`)
};

export const ws_members_roles_not_allowed = /** @type {(inputs: Ws_Members_Roles_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールを付けるには「ロールを作る・変える・付ける」の権限が要ります。`)
};

export const ws_members_search = /** @type {(inputs: Ws_Members_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前で絞る`)
};

export const ws_members_select = /** @type {(inputs: Ws_Members_SelectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を選ぶ`)
};

export const ws_members_select_all = /** @type {(inputs: Ws_Members_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて選ぶ`)
};

export const ws_members_selected = /** @type {(inputs: Ws_Members_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人を選んでいます`)
};

export const ws_members_to_guest_body = /** @type {(inputs: Ws_Members_To_Guest_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付いているロールと Space の管理者が外れ、見えなくなる Space から抜けます。Member に戻しても元には戻りません。`)
};

export const ws_members_to_guest_note = /** @type {(inputs: Ws_Members_To_Guest_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest は、全員に見える Space と参加した Space だけを見られます`)
};

export const ws_members_to_guest_title = /** @type {(inputs: Ws_Members_To_Guest_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を Guest にしますか`)
};

export const ws_members_to_member_note = /** @type {(inputs: Ws_Members_To_Member_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member に戻すと、メンバー向けの Space も見えるようになります`)
};

export const ws_menu = /** @type {(inputs: Ws_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のメニュー`)
};

export const ws_menu_invite = /** @type {(inputs: Ws_Menu_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待する`)
};

export const ws_menu_new = /** @type {(inputs: Ws_Menu_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を作る`)
};

export const ws_menu_settings = /** @type {(inputs: Ws_Menu_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

export const ws_missing_body = /** @type {(inputs: Ws_Missing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace は無いか、まだ参加していません。招待のリンクから参加できます。`)
};

export const ws_missing_title = /** @type {(inputs: Ws_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace が見つかりません`)
};

export const ws_my_cases = /** @type {(inputs: Ws_My_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の Case`)
};

export const ws_my_cases_chip = /** @type {(inputs: Ws_My_Cases_ChipInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`これを指す自分の Case が ${i?.count} 件`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`これを指す自分の Case が ${i?.count} 件`);
	return /** @type {LocalizedString} */ ("ws_my_cases_chip");
};

export const ws_new_create = /** @type {(inputs: Ws_New_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作る`)
};

export const ws_new_description = /** @type {(inputs: Ws_New_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームの会話・文書・Issue を置く場所。作った人がオーナーになります。`)
};

export const ws_new_failed = /** @type {(inputs: Ws_New_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を作れませんでした`)
};

export const ws_new_title = /** @type {(inputs: Ws_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を作る`)
};

export const ws_perm_emoji_create = /** @type {(inputs: Ws_Perm_Emoji_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絵文字を足す`)
};

export const ws_perm_emoji_manage = /** @type {(inputs: Ws_Perm_Emoji_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誰の絵文字でも消す`)
};

export const ws_perm_issue_manage = /** @type {(inputs: Ws_Perm_Issue_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue と Project を管理する`)
};

export const ws_perm_member_manage = /** @type {(inputs: Ws_Perm_Member_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーを外す・種別を変える`)
};

export const ws_perm_message_write = /** @type {(inputs: Ws_Perm_Message_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話に書く`)
};

export const ws_perm_page_write = /** @type {(inputs: Ws_Perm_Page_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文書を作る・書く`)
};

export const ws_perm_role_manage = /** @type {(inputs: Ws_Perm_Role_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールを作る・変える・付ける`)
};

export const ws_perm_space_manage = /** @type {(inputs: Ws_Perm_Space_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space を作る`)
};

export const ws_perm_workspace_invite = /** @type {(inputs: Ws_Perm_Workspace_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待のリンクを発行・失効する`)
};

export const ws_perm_workspace_manage = /** @type {(inputs: Ws_Perm_Workspace_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace の名前・URL・機能を変える`)
};

export const ws_profile_avatar = /** @type {(inputs: Ws_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイコン`)
};

export const ws_profile_avatar_note = /** @type {(inputs: Ws_Profile_Avatar_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace だけで使うアイコン。決めていなければアカウントのアイコンが出ます`)
};

export const ws_profile_avatar_reset = /** @type {(inputs: Ws_Profile_Avatar_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントと同じにする`)
};

export const ws_profile_name = /** @type {(inputs: Ws_Profile_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示名`)
};

export const ws_profile_name_note = /** @type {(inputs: Ws_Profile_Name_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace の人に見える名前`)
};

export const ws_rail = /** @type {(inputs: Ws_RailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const ws_rail_new = /** @type {(inputs: Ws_Rail_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace を作る`)
};

export const ws_roles_above_you = /** @type {(inputs: Ws_Roles_Above_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分の一番上のロールと同じか上のロールは変えられません。`)
};

export const ws_roles_create = /** @type {(inputs: Ws_Roles_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作る`)
};

export const ws_roles_create_failed = /** @type {(inputs: Ws_Roles_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールを作れませんでした`)
};

export const ws_roles_default_note = /** @type {(inputs: Ws_Roles_Default_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全員に付いているロール。名前と位置は変えられず、消せません。`)
};

export const ws_roles_default_sub = /** @type {(inputs: Ws_Roles_Default_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既定(全員)`)
};

export const ws_roles_delete_body = /** @type {(inputs: Ws_Roles_Delete_BodyInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`付いている ${i?.count} 人から外れ、このロールで入る招待のリンクも消えます。`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`付いている ${i?.count} 人から外れ、このロールで入る招待のリンクも消えます。`);
	return /** @type {LocalizedString} */ ("ws_roles_delete_body");
};

export const ws_roles_delete_failed = /** @type {(inputs: Ws_Roles_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ロール「${i?.name}」を消せませんでした`)
};

export const ws_roles_delete_label = /** @type {(inputs: Ws_Roles_Delete_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

export const ws_roles_delete_note = /** @type {(inputs: Ws_Roles_Delete_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このロールを消します`)
};

export const ws_roles_delete_title = /** @type {(inputs: Ws_Roles_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ロール「${i?.name}」を消しますか`)
};

export const ws_roles_list = /** @type {(inputs: Ws_Roles_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールの一覧`)
};

export const ws_roles_name = /** @type {(inputs: Ws_Roles_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const ws_roles_name_example = /** @type {(inputs: Ws_Roles_Name_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 編集者`)
};

export const ws_roles_new = /** @type {(inputs: Ws_Roles_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいロール`)
};

export const ws_roles_not_allowed = /** @type {(inputs: Ws_Roles_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールを変えるには「ロールを作る・変える・付ける」の権限が要ります。`)
};

export const ws_roles_not_found = /** @type {(inputs: Ws_Roles_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このロールは見つかりませんでした`)
};

export const ws_roles_note = /** @type {(inputs: Ws_Roles_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このロールの人ができること。`)
};

export const ws_roles_only_yours = /** @type {(inputs: Ws_Roles_Only_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分が持っていない権限は付けられません。`)
};

export const ws_roles_permissions = /** @type {(inputs: Ws_Roles_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`権限`)
};

export const ws_roles_permissions_failed = /** @type {(inputs: Ws_Roles_Permissions_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の権限を変えられませんでした`)
};

export const ws_roles_position = /** @type {(inputs: Ws_Roles_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

export const ws_roles_position_note = /** @type {(inputs: Ws_Roles_Position_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きいほど上。自分の一番上のロールより下まで`)
};

export const ws_roles_position_sub = /** @type {(inputs: Ws_Roles_Position_SubInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`階層 ${i?.position}`)
};

export const ws_save_failed = /** @type {(inputs: Ws_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存できませんでした`)
};

export const ws_settings_admin = /** @type {(inputs: Ws_Settings_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者`)
};

export const ws_settings_back = /** @type {(inputs: Ws_Settings_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

export const ws_settings_features = /** @type {(inputs: Ws_Settings_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`機能`)
};

export const ws_settings_features_description = /** @type {(inputs: Ws_Settings_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace で使う機能と、外からの使い方。切った機能は全員の画面から消えます。`)
};

export const ws_settings_general = /** @type {(inputs: Ws_Settings_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般`)
};

export const ws_settings_general_description = /** @type {(inputs: Ws_Settings_General_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace のアイコン・名前・URL。`)
};

export const ws_settings_index_description = /** @type {(inputs: Ws_Settings_Index_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace での自分の設定と、Workspace の管理。`)
};

export const ws_settings_invites = /** @type {(inputs: Ws_Settings_InvitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待`)
};

export const ws_settings_invites_description = /** @type {(inputs: Ws_Settings_Invites_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加に使うリンク。回数と期限を決めて渡せます。`)
};

export const ws_settings_members = /** @type {(inputs: Ws_Settings_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバー`)
};

export const ws_settings_members_description = /** @type {(inputs: Ws_Settings_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace の人。ロールと種別を変えたり、外したりできます。`)
};

export const ws_settings_not_allowed = /** @type {(inputs: Ws_Settings_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この設定を開く権限がありません。`)
};

export const ws_settings_of = /** @type {(inputs: Ws_Settings_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の設定`)
};

export const ws_settings_personal = /** @type {(inputs: Ws_Settings_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人`)
};

export const ws_settings_profile = /** @type {(inputs: Ws_Settings_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

export const ws_settings_profile_description = /** @type {(inputs: Ws_Settings_Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Workspace で使う名前とアイコン。Workspace ごとに別に持てます。`)
};

export const ws_settings_roles = /** @type {(inputs: Ws_Settings_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロール`)
};

export const ws_settings_roles_description = /** @type {(inputs: Ws_Settings_Roles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`できることのまとまり。上のロールほど強く、自分より下のロールだけを変えられます。`)
};

export const ws_settings_spaces = /** @type {(inputs: Ws_Settings_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const ws_settings_spaces_description = /** @type {(inputs: Ws_Settings_Spaces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話や文書を置く場所。誰が見られるか、どの機能を使うかを Space ごとに決めます。`)
};

export const ws_settings_title = /** @type {(inputs: Ws_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace 設定`)
};

export const ws_slug_format = /** @type {(inputs: Ws_Slug_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3〜32 文字の英小文字・数字・- で、最初と最後は英数字にしてください`)
};

export const ws_slug_reserved = /** @type {(inputs: Ws_Slug_ReservedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この URL は使えません`)
};

export const ws_slug_taken = /** @type {(inputs: Ws_Slug_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この URL は使われています`)
};

export const ws_spaces_add_manager = /** @type {(inputs: Ws_Spaces_Add_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者を足す`)
};

export const ws_spaces_add_member = /** @type {(inputs: Ws_Spaces_Add_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加者を足す`)
};

export const ws_spaces_anyone_note = /** @type {(inputs: Ws_Spaces_Anyone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest も含め、この Workspace の全員が見られます`)
};

export const ws_spaces_archive = /** @type {(inputs: Ws_Spaces_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ`)
};

export const ws_spaces_archive_label = /** @type {(inputs: Ws_Spaces_Archive_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブと削除`)
};

export const ws_spaces_archive_note = /** @type {(inputs: Ws_Spaces_Archive_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーから外し、中身は残します`)
};

export const ws_spaces_archived = /** @type {(inputs: Ws_Spaces_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ`)
};

export const ws_spaces_archived_note = /** @type {(inputs: Ws_Spaces_Archived_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーカイブ中。サイドバーには出ません`)
};

export const ws_spaces_create = /** @type {(inputs: Ws_Spaces_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作る`)
};

export const ws_spaces_create_failed = /** @type {(inputs: Ws_Spaces_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space を作れませんでした`)
};

export const ws_spaces_create_not_allowed = /** @type {(inputs: Ws_Spaces_Create_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space を作るには「Space を作る」の権限が要ります。`)
};

export const ws_spaces_delete_body = /** @type {(inputs: Ws_Spaces_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中の会話・文書・Issue も見えなくなり、参加者と管理者も外れます。`)
};

export const ws_spaces_delete_failed = /** @type {(inputs: Ws_Spaces_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Space「${i?.name}」を消せませんでした`)
};

export const ws_spaces_delete_note = /** @type {(inputs: Ws_Spaces_Delete_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space を消します`)
};

export const ws_spaces_delete_title = /** @type {(inputs: Ws_Spaces_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Space「${i?.name}」を消しますか`)
};

export const ws_spaces_description = /** @type {(inputs: Ws_Spaces_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

export const ws_spaces_description_placeholder = /** @type {(inputs: Ws_Spaces_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何のための Space か`)
};

export const ws_spaces_features = /** @type {(inputs: Ws_Spaces_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使う機能`)
};

export const ws_spaces_features_failed = /** @type {(inputs: Ws_Spaces_Features_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の機能を変えられませんでした`)
};

export const ws_spaces_list = /** @type {(inputs: Ws_Spaces_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space の一覧`)
};

export const ws_spaces_managers = /** @type {(inputs: Ws_Spaces_ManagersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者`)
};

export const ws_spaces_members = /** @type {(inputs: Ws_Spaces_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加者`)
};

export const ws_spaces_members_note = /** @type {(inputs: Ws_Spaces_Members_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member が見られます。Guest には見えません`)
};

export const ws_spaces_name = /** @type {(inputs: Ws_Spaces_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前`)
};

export const ws_spaces_narrow = /** @type {(inputs: Ws_Spaces_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変える`)
};

export const ws_spaces_narrow_members_body = /** @type {(inputs: Ws_Spaces_Narrow_Members_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest からは、この Space がすぐに見えなくなります。`)
};

export const ws_spaces_narrow_private_body = /** @type {(inputs: Ws_Spaces_Narrow_Private_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加者でない人からは、この Space がすぐに見えなくなります。管理者とあなたは参加者に加わります。`)
};

export const ws_spaces_narrow_title = /** @type {(inputs: Ws_Spaces_Narrow_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を「${i?.visibility}」にしますか`)
};

export const ws_spaces_new = /** @type {(inputs: Ws_Spaces_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい Space`)
};

export const ws_spaces_no_managers = /** @type {(inputs: Ws_Spaces_No_ManagersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者はいません`)
};

export const ws_spaces_no_members = /** @type {(inputs: Ws_Spaces_No_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ参加者はいません`)
};

export const ws_spaces_not_allowed = /** @type {(inputs: Ws_Spaces_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space を変えられるのは、Space の管理者と Workspace を管理する人です。`)
};

export const ws_spaces_not_found = /** @type {(inputs: Ws_Spaces_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この Space は見つかりませんでした`)
};

export const ws_spaces_private_note = /** @type {(inputs: Ws_Spaces_Private_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加者だけが見られます`)
};

export const ws_spaces_remove_person = /** @type {(inputs: Ws_Spaces_Remove_PersonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外す`)
};

export const ws_spaces_remove_person_failed = /** @type {(inputs: Ws_Spaces_Remove_Person_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を外せませんでした`)
};

export const ws_spaces_unarchive = /** @type {(inputs: Ws_Spaces_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻す`)
};

export const ws_spaces_unarchive_note = /** @type {(inputs: Ws_Spaces_Unarchive_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイドバーに戻します`)
};

export const ws_spaces_visibility = /** @type {(inputs: Ws_Spaces_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`見られる人`)
};

export const ws_visibility_anyone = /** @type {(inputs: Ws_Visibility_AnyoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全員`)
};

export const ws_visibility_members = /** @type {(inputs: Ws_Visibility_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member だけ`)
};

export const ws_visibility_private = /** @type {(inputs: Ws_Visibility_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参加者だけ`)
};